/**
 * Prisma Enums — the members of `DbEnum`, one top-level export each.
 *
 * ⚠️ DO NOT EDIT THIS FILE MANUALLY! Generated by `pnpm generate:enums` from
 * packages/prisma-db/schema.prisma, beside `prisma-enums.ts`, which names
 * them `DbEnum`. See packages/types/scripts/generate-enums.ts for why the
 * members live here rather than inside a `namespace`.
 *
 * @enums 195
 */

/**
 * rule is already live and already diverging for those 6 rows.
 *
 * Values: SHARED | PERSONAL
 *
 * @generated from schema.prisma:1048
 */
export enum CredentialSharing {
  SHARED = "SHARED",
  PERSONAL = "PERSONAL",
}

/** All values of CredentialSharing */
export const CREDENTIAL_SHARING_VALUES = ['SHARED', 'PERSONAL'] as const;

/**
 * Regulatory compliance bundle status for phone number purchase.
 *
 * Values: NOT_STARTED | DRAFT | PENDING | APPROVED | REJECTED
 *
 * @generated from schema.prisma:1359
 */
export enum ComplianceBundleStatus {
  NOT_STARTED = "NOT_STARTED",
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

/** All values of ComplianceBundleStatus */
export const COMPLIANCE_BUNDLE_STATUS_VALUES = ['NOT_STARTED', 'DRAFT', 'PENDING', 'APPROVED', 'REJECTED'] as const;

/**
 * A2P 10DLC registration status for US SMS/MMS messaging compliance.
 *
 * Values: NOT_STARTED | DRAFT | PENDING_BRAND | PENDING_CAMPAIGN | APPROVED | REJECTED
 *
 * @generated from schema.prisma:1411
 */
export enum A2pRegistrationStatus {
  NOT_STARTED = "NOT_STARTED",
  DRAFT = "DRAFT",
  PENDING_BRAND = "PENDING_BRAND",
  PENDING_CAMPAIGN = "PENDING_CAMPAIGN",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

/** All values of A2pRegistrationStatus */
export const A2P_REGISTRATION_STATUS_VALUES = ['NOT_STARTED', 'DRAFT', 'PENDING_BRAND', 'PENDING_CAMPAIGN', 'APPROVED', 'REJECTED'] as const;

/**
 * Agent creation thread status
 *
 * Values: IN_PROGRESS | GENERATING | COMPLETED | FAILED | CANCELLED
 *
 * @generated from schema.prisma:1460
 */
export enum AgentCreationThreadStatus {
  IN_PROGRESS = "IN_PROGRESS",
  GENERATING = "GENERATING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

/** All values of AgentCreationThreadStatus */
export const AGENT_CREATION_THREAD_STATUS_VALUES = ['IN_PROGRESS', 'GENERATING', 'COMPLETED', 'FAILED', 'CANCELLED'] as const;

/**
 * `DbEnum.MODEL_PROVIDER_VALUES` is what code should iterate.
 *
 * Values: OPEN_AI | ANTHROPIC | GOOGLE_AI | KIMI | JEV
 *
 * @generated from schema.prisma:1766
 */
export enum ModelProvider {
  OPEN_AI = "OPEN_AI",
  ANTHROPIC = "ANTHROPIC",
  GOOGLE_AI = "GOOGLE_AI",
  KIMI = "KIMI",
  JEV = "JEV",
}

/** All values of ModelProvider */
export const MODEL_PROVIDER_VALUES = ['OPEN_AI', 'ANTHROPIC', 'GOOGLE_AI', 'KIMI', 'JEV'] as const;

/**
 * Set at create and never changed after.
 *
 * Values: GENERATIVE | DECISION
 *
 * @generated from schema.prisma:1777
 */
export enum AITaskKind {
  GENERATIVE = "GENERATIVE",
  DECISION = "DECISION",
}

/** All values of AITaskKind */
export const A_I_TASK_KIND_VALUES = ['GENERATIVE', 'DECISION'] as const;

/**
 * Input format for AI task processing
 *
 * Values: JSON | TEXT
 *
 * @generated from schema.prisma:1783
 */
export enum AITaskInputFormat {
  JSON = "JSON",
  TEXT = "TEXT",
}

/** All values of AITaskInputFormat */
export const A_I_TASK_INPUT_FORMAT_VALUES = ['JSON', 'TEXT'] as const;

/**
 * Output format for AI task results
 *
 * Values: JSON | TEXT | TEMPLATE
 *
 * @generated from schema.prisma:1789
 */
export enum AITaskOutputFormat {
  JSON = "JSON",
  TEXT = "TEXT",
  TEMPLATE = "TEMPLATE",
}

/** All values of AITaskOutputFormat */
export const A_I_TASK_OUTPUT_FORMAT_VALUES = ['JSON', 'TEXT', 'TEMPLATE'] as const;

/**
 * Enforced by a CHECK per table: ATTRIBUTED ⟺ `deploymentId IS NOT NULL`.
 *
 * Values: ATTRIBUTED | NOT_APPLICABLE | UNRESOLVED
 *
 * @generated from schema.prisma:2419
 */
export enum DeploymentAttribution {
  ATTRIBUTED = "ATTRIBUTED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  UNRESOLVED = "UNRESOLVED",
}

/** All values of DeploymentAttribution */
export const DEPLOYMENT_ATTRIBUTION_VALUES = ['ATTRIBUTED', 'NOT_APPLICABLE', 'UNRESOLVED'] as const;

/**
 * so a later re-run would skip them as already visited.
 *
 * Values: CHAT | MESSAGE | WORKFLOW_EXECUTION | WORKFLOW_EXECUTION_NODE | SCORE
 *
 * @generated from schema.prisma:2448
 */
export enum AttributionBackfillTable {
  CHAT = "CHAT",
  MESSAGE = "MESSAGE",
  WORKFLOW_EXECUTION = "WORKFLOW_EXECUTION",
  WORKFLOW_EXECUTION_NODE = "WORKFLOW_EXECUTION_NODE",
  SCORE = "SCORE",
}

/** All values of AttributionBackfillTable */
export const ATTRIBUTION_BACKFILL_TABLE_VALUES = ['CHAT', 'MESSAGE', 'WORKFLOW_EXECUTION', 'WORKFLOW_EXECUTION_NODE', 'SCORE'] as const;

/**
 * Where one table's sweep stands.
 *
 * Values: IDLE | RUNNING | COMPLETED | FAILED
 *
 * @generated from schema.prisma:2457
 */
export enum AttributionBackfillStatus {
  IDLE = "IDLE",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of AttributionBackfillStatus */
export const ATTRIBUTION_BACKFILL_STATUS_VALUES = ['IDLE', 'RUNNING', 'COMPLETED', 'FAILED'] as const;

/**
 * Status of a Browserbase browser automation session
 *
 * Values: RUNNING | IDLE | COMPLETED | FAILED | EXPIRED | TERMINATED
 *
 * @generated from schema.prisma:2666
 */
export enum BrowserbaseSessionStatus {
  RUNNING = "RUNNING",
  IDLE = "IDLE",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  TERMINATED = "TERMINATED",
}

/** All values of BrowserbaseSessionStatus */
export const BROWSERBASE_SESSION_STATUS_VALUES = ['RUNNING', 'IDLE', 'COMPLETED', 'FAILED', 'EXPIRED', 'TERMINATED'] as const;

/**
 * Health status from Browserbase API health checks
 *
 * Values: UNKNOWN | HEALTHY | DEGRADED | UNHEALTHY
 *
 * @generated from schema.prisma:2676
 */
export enum BrowserbaseSessionHealth {
  UNKNOWN = "UNKNOWN",
  HEALTHY = "HEALTHY",
  DEGRADED = "DEGRADED",
  UNHEALTHY = "UNHEALTHY",
}

/** All values of BrowserbaseSessionHealth */
export const BROWSERBASE_SESSION_HEALTH_VALUES = ['UNKNOWN', 'HEALTHY', 'DEGRADED', 'UNHEALTHY'] as const;

/**
 * Lifecycle state for a provisioned phone number.
 *
 * Values: ACTIVE | PENDING_RELEASE | RELEASING | RELEASED | DELETED
 *
 * @generated from schema.prisma:3770
 */
export enum PhoneNumberStatus {
  ACTIVE = "ACTIVE",
  PENDING_RELEASE = "PENDING_RELEASE",
  RELEASING = "RELEASING",
  RELEASED = "RELEASED",
  DELETED = "DELETED",
}

/** All values of PhoneNumberStatus */
export const PHONE_NUMBER_STATUS_VALUES = ['ACTIVE', 'PENDING_RELEASE', 'RELEASING', 'RELEASED', 'DELETED'] as const;

/**
 * What the phone number will be used for
 *
 * Values: SMS | VOICE | WHATSAPP | SMS_AND_VOICE | ALL
 *
 * @generated from schema.prisma:3871
 */
export enum PhoneNumberUseCase {
  SMS = "SMS",
  VOICE = "VOICE",
  WHATSAPP = "WHATSAPP",
  SMS_AND_VOICE = "SMS_AND_VOICE",
  ALL = "ALL",
}

/** All values of PhoneNumberUseCase */
export const PHONE_NUMBER_USE_CASE_VALUES = ['SMS', 'VOICE', 'WHATSAPP', 'SMS_AND_VOICE', 'ALL'] as const;

/**
 * Status of phone number request
 *
 * Values: PENDING | APPROVED | REJECTED | PROVISIONING | COMPLETED | FAILED | CANCELLED
 *
 * @generated from schema.prisma:3880
 */
export enum PhoneNumberRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PROVISIONING = "PROVISIONING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

/** All values of PhoneNumberRequestStatus */
export const PHONE_NUMBER_REQUEST_STATUS_VALUES = ['PENDING', 'APPROVED', 'REJECTED', 'PROVISIONING', 'COMPLETED', 'FAILED', 'CANCELLED'] as const;

/**
 * a conversation past its window.
 *
 * Values: ARCHIVE | DELETE | SHRED
 *
 * @generated from schema.prisma:4102
 */
export enum ChatRetentionAction {
  ARCHIVE = "ARCHIVE",
  DELETE = "DELETE",
  SHRED = "SHRED",
}

/** All values of ChatRetentionAction */
export const CHAT_RETENTION_ACTION_VALUES = ['ARCHIVE', 'DELETE', 'SHRED'] as const;

/**
 * have no participant rows and are unaffected.
 *
 * Values: MEMBER | ADMIN
 *
 * @generated from schema.prisma:4451
 */
export enum SessionParticipantRole {
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
}

/** All values of SessionParticipantRole */
export const SESSION_PARTICIPANT_ROLE_VALUES = ['MEMBER', 'ADMIN'] as const;

/**
 * Values: ACTIVE | REMOVED | LEFT
 *
 * @generated from schema.prisma:4456
 */
export enum SessionParticipantStatus {
  ACTIVE = "ACTIVE",
  REMOVED = "REMOVED",
  LEFT = "LEFT",
}

/** All values of SessionParticipantStatus */
export const SESSION_PARTICIPANT_STATUS_VALUES = ['ACTIVE', 'REMOVED', 'LEFT'] as const;

/**
 * Customer view visibility levels
 *
 * Values: PERSONAL | SHARED | SHARED_LOCKED
 *
 * @generated from schema.prisma:4484
 */
export enum CustomerViewVisibility {
  PERSONAL = "PERSONAL",
  SHARED = "SHARED",
  SHARED_LOCKED = "SHARED_LOCKED",
}

/** All values of CustomerViewVisibility */
export const CUSTOMER_VIEW_VISIBILITY_VALUES = ['PERSONAL', 'SHARED', 'SHARED_LOCKED'] as const;

/**
 * of LEGACY_5_STAR — see the field comment on `SatisfactionScore.rawScore`.
 *
 * Values: LEGACY_5_STAR | THUMBS | NPS | CSAT | AI_PASSIVE | CUSTOM
 *
 * @generated from schema.prisma:4637
 */
export enum SatisfactionFramework {
  LEGACY_5_STAR = "LEGACY_5_STAR",
  THUMBS = "THUMBS",
  NPS = "NPS",
  CSAT = "CSAT",
  AI_PASSIVE = "AI_PASSIVE",
  CUSTOM = "CUSTOM",
}

/** All values of SatisfactionFramework */
export const SATISFACTION_FRAMEWORK_VALUES = ['LEGACY_5_STAR', 'THUMBS', 'NPS', 'CSAT', 'AI_PASSIVE', 'CUSTOM'] as const;

/**
 * LEGACY rows predate the source column (backfilled).
 *
 * Values: CUSTOMER_PROMPTED | AI_PASSIVE | LEGACY
 *
 * @generated from schema.prisma:4648
 */
export enum SatisfactionSource {
  CUSTOMER_PROMPTED = "CUSTOMER_PROMPTED",
  AI_PASSIVE = "AI_PASSIVE",
  LEGACY = "LEGACY",
}

/** All values of SatisfactionSource */
export const SATISFACTION_SOURCE_VALUES = ['CUSTOMER_PROMPTED', 'AI_PASSIVE', 'LEGACY'] as const;

/**
 * references one of these by id with NO foreign key (it targets many tables).
 *
 * Values: MESSAGE | CHAT | GENERATION | TRACE | WORKFLOW_EXECUTION | WORKFLOW_EXECUTION_NODE
 *
 * @generated from schema.prisma:4734
 */
export enum ScorableType {
  MESSAGE = "MESSAGE",
  CHAT = "CHAT",
  GENERATION = "GENERATION",
  TRACE = "TRACE",
  WORKFLOW_EXECUTION = "WORKFLOW_EXECUTION",
  WORKFLOW_EXECUTION_NODE = "WORKFLOW_EXECUTION_NODE",
}

/** All values of ScorableType */
export const SCORABLE_TYPE_VALUES = ['MESSAGE', 'CHAT', 'GENERATION', 'TRACE', 'WORKFLOW_EXECUTION', 'WORKFLOW_EXECUTION_NODE'] as const;

/**
 * discriminator (enforced by a DB CHECK constraint).
 *
 * Values: NUMERIC | CATEGORICAL | BOOLEAN
 *
 * @generated from schema.prisma:4746
 */
export enum ScoreValueType {
  NUMERIC = "NUMERIC",
  CATEGORICAL = "CATEGORICAL",
  BOOLEAN = "BOOLEAN",
}

/** All values of ScoreValueType */
export const SCORE_VALUE_TYPE_VALUES = ['NUMERIC', 'CATEGORICAL', 'BOOLEAN'] as const;

/**
 * Analytics v2 L2 — what produced a Score.
 *
 * Values: EVAL_JUDGE | WORKFLOW_NODE | CSAT | SYSTEM_EVENT | CUSTOM_KPI | HUMAN
 *
 * @generated from schema.prisma:4753
 */
export enum ScoreEmitterType {
  EVAL_JUDGE = "EVAL_JUDGE",
  WORKFLOW_NODE = "WORKFLOW_NODE",
  CSAT = "CSAT",
  SYSTEM_EVENT = "SYSTEM_EVENT",
  CUSTOM_KPI = "CUSTOM_KPI",
  HUMAN = "HUMAN",
}

/** All values of ScoreEmitterType */
export const SCORE_EMITTER_TYPE_VALUES = ['EVAL_JUDGE', 'WORKFLOW_NODE', 'CSAT', 'SYSTEM_EVENT', 'CUSTOM_KPI', 'HUMAN'] as const;

/**
 * Workflow publication status
 *
 * Values: DRAFT | PUBLISHED | ARCHIVED | PAUSED
 *
 * @generated from schema.prisma:5046
 */
export enum WorkflowStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
  PAUSED = "PAUSED",
}

/** All values of WorkflowStatus */
export const WORKFLOW_STATUS_VALUES = ['DRAFT', 'PUBLISHED', 'ARCHIVED', 'PAUSED'] as const;

/**
 * Type of workflow trigger
 *
 * Values: UNDETERMINED | SCHEDULE | WEBHOOK | AGENT | MANUAL
 *
 * @generated from schema.prisma:5054
 */
export enum WorkflowTriggerType {
  UNDETERMINED = "UNDETERMINED",
  SCHEDULE = "SCHEDULE",
  WEBHOOK = "WEBHOOK",
  AGENT = "AGENT",
  MANUAL = "MANUAL",
}

/** All values of WorkflowTriggerType */
export const WORKFLOW_TRIGGER_TYPE_VALUES = ['UNDETERMINED', 'SCHEDULE', 'WEBHOOK', 'AGENT', 'MANUAL'] as const;

/**
 * this column exists for: "what started the run this row belongs to".
 *
 * Values: WEBHOOK | SCHEDULE | PLATFORM_EVENT | AGENT_INPUT | RETRIGGER | WORKFLOW_TEST | NODE_TEST | UNKNOWN
 *
 * @generated from schema.prisma:5086
 */
export enum WorkflowExecutionTrigger {
  WEBHOOK = "WEBHOOK",
  SCHEDULE = "SCHEDULE",
  PLATFORM_EVENT = "PLATFORM_EVENT",
  AGENT_INPUT = "AGENT_INPUT",
  RETRIGGER = "RETRIGGER",
  WORKFLOW_TEST = "WORKFLOW_TEST",
  NODE_TEST = "NODE_TEST",
  UNKNOWN = "UNKNOWN",
}

/** All values of WorkflowExecutionTrigger */
export const WORKFLOW_EXECUTION_TRIGGER_VALUES = ['WEBHOOK', 'SCHEDULE', 'PLATFORM_EVENT', 'AGENT_INPUT', 'RETRIGGER', 'WORKFLOW_TEST', 'NODE_TEST', 'UNKNOWN'] as const;

/**
 * and a frontend settings panel (drift-detector enforces this).
 *
 * Values: SATISFACTION_EVALUATION
 *
 * @generated from schema.prisma:5124
 */
export enum WorkflowPresetSource {
  SATISFACTION_EVALUATION = "SATISFACTION_EVALUATION",
}

/** All values of WorkflowPresetSource */
export const WORKFLOW_PRESET_SOURCE_VALUES = ['SATISFACTION_EVALUATION'] as const;

/**
 * Trigger execution type
 *
 * Values: SCHEDULED | WEBHOOK
 *
 * @generated from schema.prisma:5129
 */
export enum TriggerType {
  SCHEDULED = "SCHEDULED",
  WEBHOOK = "WEBHOOK",
}

/** All values of TriggerType */
export const TRIGGER_TYPE_VALUES = ['SCHEDULED', 'WEBHOOK'] as const;

/**
 * Trigger environment (test vs production)
 *
 * Values: TEST | PRODUCTION
 *
 * @generated from schema.prisma:5135
 */
export enum TriggerEnvironment {
  TEST = "TEST",
  PRODUCTION = "PRODUCTION",
}

/** All values of TriggerEnvironment */
export const TRIGGER_ENVIRONMENT_VALUES = ['TEST', 'PRODUCTION'] as const;

/**
 * Workflow node execution state
 *
 * Values: PENDING | READY | RUNNING | COMPLETED | SKIPPED | WAITING | ERROR
 *
 * @generated from schema.prisma:5141
 */
export enum NodeState {
  PENDING = "PENDING",
  READY = "READY",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  SKIPPED = "SKIPPED",
  WAITING = "WAITING",
  ERROR = "ERROR",
}

/** All values of NodeState */
export const NODE_STATE_VALUES = ['PENDING', 'READY', 'RUNNING', 'COMPLETED', 'SKIPPED', 'WAITING', 'ERROR'] as const;

/**
 * Workflow execution status
 *
 * Values: PENDING | RUNNING | FAILED | COMPLETED | CANCELLED
 *
 * @generated from schema.prisma:5152
 */
export enum WorkflowExecutionStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** All values of WorkflowExecutionStatus */
export const WORKFLOW_EXECUTION_STATUS_VALUES = ['PENDING', 'RUNNING', 'FAILED', 'COMPLETED', 'CANCELLED'] as const;

/**
 * Meta conversation status for agent planning
 *
 * Values: PENDING | ACTIVE | COMPLETED | CANCELLED
 *
 * @generated from schema.prisma:5161
 */
export enum MetaConversationStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

/** All values of MetaConversationStatus */
export const META_CONVERSATION_STATUS_VALUES = ['PENDING', 'ACTIVE', 'COMPLETED', 'CANCELLED'] as const;

/**
 * Document template save status
 *
 * Values: DRAFT | SAVED
 *
 * @generated from schema.prisma:5169
 */
export enum DocumentTemplateStatus {
  DRAFT = "DRAFT",
  SAVED = "SAVED",
}

/** All values of DocumentTemplateStatus */
export const DOCUMENT_TEMPLATE_STATUS_VALUES = ['DRAFT', 'SAVED'] as const;

/**
 * Document template type (Word, PowerPoint, Excel)
 *
 * Values: WORD_FORMAT | WORD_TEMPLATE | WORD_CONTENT | POWERPOINT_TEMPLATE | POWERPOINT_SPLIT | EXCEL_TEMPLATE
 *
 * @generated from schema.prisma:5175
 */
export enum DocumentTemplateType {
  WORD_FORMAT = "WORD_FORMAT",
  WORD_TEMPLATE = "WORD_TEMPLATE",
  WORD_CONTENT = "WORD_CONTENT",
  POWERPOINT_TEMPLATE = "POWERPOINT_TEMPLATE",
  POWERPOINT_SPLIT = "POWERPOINT_SPLIT",
  EXCEL_TEMPLATE = "EXCEL_TEMPLATE",
}

/** All values of DocumentTemplateType */
export const DOCUMENT_TEMPLATE_TYPE_VALUES = ['WORD_FORMAT', 'WORD_TEMPLATE', 'WORD_CONTENT', 'POWERPOINT_TEMPLATE', 'POWERPOINT_SPLIT', 'EXCEL_TEMPLATE'] as const;

/**
 * Usability state for resources
 *
 * Values: ALWAYS_USABLE | SINGLE_USE | ALREADY_USED
 *
 * @generated from schema.prisma:5185
 */
export enum UsabilityState {
  ALWAYS_USABLE = "ALWAYS_USABLE",
  SINGLE_USE = "SINGLE_USE",
  ALREADY_USED = "ALREADY_USED",
}

/** All values of UsabilityState */
export const USABILITY_STATE_VALUES = ['ALWAYS_USABLE', 'SINGLE_USE', 'ALREADY_USED'] as const;

/**
 * Document re-sync type
 *
 * Values: NONE | MANUAL | AUTO
 *
 * @generated from schema.prisma:5192
 */
export enum ReSyncType {
  NONE = "NONE",
  MANUAL = "MANUAL",
  AUTO = "AUTO",
}

/** All values of ReSyncType */
export const RE_SYNC_TYPE_VALUES = ['NONE', 'MANUAL', 'AUTO'] as const;

/**
 * User role in organization
 *
 * Values: USER | ADMIN
 *
 * @generated from schema.prisma:5199
 */
export enum UserRole {
  USER = "USER",
  ADMIN = "ADMIN",
}

/** All values of UserRole */
export const USER_ROLE_VALUES = ['USER', 'ADMIN'] as const;

/**
 * Billing method type for payments
 *
 * Values: BALANCE | API_KEY
 *
 * @generated from schema.prisma:5205
 */
export enum BillingMethodType {
  BALANCE = "BALANCE",
  API_KEY = "API_KEY",
}

/** All values of BillingMethodType */
export const BILLING_METHOD_TYPE_VALUES = ['BALANCE', 'API_KEY'] as const;

/**
 * Type of charge (subscription vs one-time top-up)
 *
 * Values: SUBSCRIPTION | TOPUP
 *
 * @generated from schema.prisma:5211
 */
export enum ChargeType {
  SUBSCRIPTION = "SUBSCRIPTION",
  TOPUP = "TOPUP",
}

/** All values of ChargeType */
export const CHARGE_TYPE_VALUES = ['SUBSCRIPTION', 'TOPUP'] as const;

/**
 * Subscription tier level
 *
 * Values: PAY_AS_YOU_GO | HOBBY | PRO | ENTERPRISE
 *
 * @generated from schema.prisma:5217
 */
export enum SubscriptionType {
  PAY_AS_YOU_GO = "PAY_AS_YOU_GO",
  HOBBY = "HOBBY",
  PRO = "PRO",
  ENTERPRISE = "ENTERPRISE",
}

/** All values of SubscriptionType */
export const SUBSCRIPTION_TYPE_VALUES = ['PAY_AS_YOU_GO', 'HOBBY', 'PRO', 'ENTERPRISE'] as const;

/**
 * Subscription payment status
 *
 * Values: ACTIVE | INCOMPLETE | INCOMPLETE_EXPIRED | TRIALING | PAST_DUE | CANCELED | UNPAID | PAUSED
 *
 * @generated from schema.prisma:5225
 */
export enum SubscriptionStatus {
  ACTIVE = "ACTIVE",
  INCOMPLETE = "INCOMPLETE",
  INCOMPLETE_EXPIRED = "INCOMPLETE_EXPIRED",
  TRIALING = "TRIALING",
  PAST_DUE = "PAST_DUE",
  CANCELED = "CANCELED",
  UNPAID = "UNPAID",
  PAUSED = "PAUSED",
}

/** All values of SubscriptionStatus */
export const SUBSCRIPTION_STATUS_VALUES = ['ACTIVE', 'INCOMPLETE', 'INCOMPLETE_EXPIRED', 'TRIALING', 'PAST_DUE', 'CANCELED', 'UNPAID', 'PAUSED'] as const;

/**
 * Document file type
 *
 * Values: PDF | CSV | TEXT | IMAGE | AUDIO | WEBSITE_FOLDER | WEBSITE_PAGE | NOTION_PAGE | NOTION_DATABASE | GOOGLE_DOC | GOOGLE_SHEET | GOOGLE_DRIVE | SHAREPOINT | AIRTABLE_BASE | AIRTABLE_TABLE | FOLDER | UNKNOWN
 *
 * @generated from schema.prisma:5240
 */
export enum DocumentType {
  PDF = "PDF",
  CSV = "CSV",
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  WEBSITE_FOLDER = "WEBSITE_FOLDER",
  WEBSITE_PAGE = "WEBSITE_PAGE",
  NOTION_PAGE = "NOTION_PAGE",
  NOTION_DATABASE = "NOTION_DATABASE",
  GOOGLE_DOC = "GOOGLE_DOC",
  GOOGLE_SHEET = "GOOGLE_SHEET",
  GOOGLE_DRIVE = "GOOGLE_DRIVE",
  SHAREPOINT = "SHAREPOINT",
  AIRTABLE_BASE = "AIRTABLE_BASE",
  AIRTABLE_TABLE = "AIRTABLE_TABLE",
  FOLDER = "FOLDER",
  UNKNOWN = "UNKNOWN",
}

/** All values of DocumentType */
export const DOCUMENT_TYPE_VALUES = ['PDF', 'CSV', 'TEXT', 'IMAGE', 'AUDIO', 'WEBSITE_FOLDER', 'WEBSITE_PAGE', 'NOTION_PAGE', 'NOTION_DATABASE', 'GOOGLE_DOC', 'GOOGLE_SHEET', 'GOOGLE_DRIVE', 'SHAREPOINT', 'AIRTABLE_BASE', 'AIRTABLE_TABLE', 'FOLDER', 'UNKNOWN'] as const;

/**
 * Source from which document was ingested
 *
 * Values: FILE | WEBSITE | DEPLOYMENT | TEXT | API | GOOGLE_SHEET | GOOGLE_DRIVE | SHAREPOINT | NOTION
 *
 * @generated from schema.prisma:5261
 */
export enum DocumentSourceType {
  FILE = "FILE",
  WEBSITE = "WEBSITE",
  DEPLOYMENT = "DEPLOYMENT",
  TEXT = "TEXT",
  API = "API",
  GOOGLE_SHEET = "GOOGLE_SHEET",
  GOOGLE_DRIVE = "GOOGLE_DRIVE",
  SHAREPOINT = "SHAREPOINT",
  NOTION = "NOTION",
}

/** All values of DocumentSourceType */
export const DOCUMENT_SOURCE_TYPE_VALUES = ['FILE', 'WEBSITE', 'DEPLOYMENT', 'TEXT', 'API', 'GOOGLE_SHEET', 'GOOGLE_DRIVE', 'SHAREPOINT', 'NOTION'] as const;

/**
 * Document processing status
 *
 * Values: PENDING | PROCESSING | READY | ERROR | SYNCING
 *
 * @generated from schema.prisma:5274
 */
export enum DocumentStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  READY = "READY",
  ERROR = "ERROR",
  SYNCING = "SYNCING",
}

/** All values of DocumentStatus */
export const DOCUMENT_STATUS_VALUES = ['PENDING', 'PROCESSING', 'READY', 'ERROR', 'SYNCING'] as const;

/**
 * Document indexing status for vector search
 *
 * Values: PENDING | INDEXING | INDEXED | FAILED | NOT_INDEXED
 *
 * @generated from schema.prisma:5283
 */
export enum DocumentIndexStatus {
  PENDING = "PENDING",
  INDEXING = "INDEXING",
  INDEXED = "INDEXED",
  FAILED = "FAILED",
  NOT_INDEXED = "NOT_INDEXED",
}

/** All values of DocumentIndexStatus */
export const DOCUMENT_INDEX_STATUS_VALUES = ['PENDING', 'INDEXING', 'INDEXED', 'FAILED', 'NOT_INDEXED'] as const;

/**
 * Webhook event type for logging
 *
 * Values: MESSAGE_FINALIZED
 *
 * @generated from schema.prisma:5292
 */
export enum WebhookLogEventType {
  MESSAGE_FINALIZED = "MESSAGE_FINALIZED",
}

/** All values of WebhookLogEventType */
export const WEBHOOK_LOG_EVENT_TYPE_VALUES = ['MESSAGE_FINALIZED'] as const;

/**
 * Webhook processing status
 *
 * Values: PROCESSED | FAILED
 *
 * @generated from schema.prisma:5297
 */
export enum WebhookLogStatus {
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
}

/** All values of WebhookLogStatus */
export const WEBHOOK_LOG_STATUS_VALUES = ['PROCESSED', 'FAILED'] as const;

/**
 * API credential provider type
 *
 * Values: OPEN_AI | OTHER | LAMBDA_AI
 *
 * @generated from schema.prisma:5303
 */
export enum CredentialProvider {
  OPEN_AI = "OPEN_AI",
  OTHER = "OTHER",
  LAMBDA_AI = "LAMBDA_AI",
}

/** All values of CredentialProvider */
export const CREDENTIAL_PROVIDER_VALUES = ['OPEN_AI', 'OTHER', 'LAMBDA_AI'] as const;

/**
 * Agent privacy status
 *
 * Values: PRIVATE | PUBLIC
 *
 * @generated from schema.prisma:5310
 */
export enum VitrualEmployeePrivacyStatus {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

/** All values of VitrualEmployeePrivacyStatus */
export const VITRUAL_EMPLOYEE_PRIVACY_STATUS_VALUES = ['PRIVATE', 'PUBLIC'] as const;

/**
 * Agent publication status
 *
 * Values: DRAFT | PUBLISHED | GENERATING | PAUSED
 *
 * @generated from schema.prisma:5316
 */
export enum AgentStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  GENERATING = "GENERATING",
  PAUSED = "PAUSED",
}

/** All values of AgentStatus */
export const AGENT_STATUS_VALUES = ['DRAFT', 'PUBLISHED', 'GENERATING', 'PAUSED'] as const;

/**
 * Version type for prompt saves: AUTO (every 2min if changed) or CHECKPOINT (manual with metadata)
 *
 * Values: AUTO | CHECKPOINT
 *
 * @generated from schema.prisma:5324
 */
export enum PromptVersionType {
  AUTO = "AUTO",
  CHECKPOINT = "CHECKPOINT",
}

/** All values of PromptVersionType */
export const PROMPT_VERSION_TYPE_VALUES = ['AUTO', 'CHECKPOINT'] as const;

/**
 * CHAT  → version.content is a ChatMessage[] (role/content pairs).
 *
 * Values: TEXT | CHAT
 *
 * @generated from schema.prisma:5332
 */
export enum SystemPromptType {
  TEXT = "TEXT",
  CHAT = "CHAT",
}

/** All values of SystemPromptType */
export const SYSTEM_PROMPT_TYPE_VALUES = ['TEXT', 'CHAT'] as const;

/**
 * LLM model for agent
 *
 * Values: DEFAULT | GPT_4_TURBO | GPT_4 | GPT_4_5 | GPT_4_1 | GPT_4_1_MINI | GPT_4_1_NANO | GPT_3_5_TURBO | GPT_3_5_TURBO_16K | MISTRAL_LARGE | OPENAI_O1 | OPENAI_O1_MINI | OPENAI_O3_MINI | OPENAI_O3 | OPENAI_O3_PRO | OPENAI_O4_MINI
 *
 * @generated from schema.prisma:5338
 */
export enum AgentModel {
  DEFAULT = "DEFAULT",
  GPT_4_TURBO = "GPT_4_TURBO",
  GPT_4 = "GPT_4",
  GPT_4_5 = "GPT_4_5",
  GPT_4_1 = "GPT_4_1",
  GPT_4_1_MINI = "GPT_4_1_MINI",
  GPT_4_1_NANO = "GPT_4_1_NANO",
  GPT_3_5_TURBO = "GPT_3_5_TURBO",
  GPT_3_5_TURBO_16K = "GPT_3_5_TURBO_16K",
  MISTRAL_LARGE = "MISTRAL_LARGE",
  OPENAI_O1 = "OPENAI_O1",
  OPENAI_O1_MINI = "OPENAI_O1_MINI",
  OPENAI_O3_MINI = "OPENAI_O3_MINI",
  OPENAI_O3 = "OPENAI_O3",
  OPENAI_O3_PRO = "OPENAI_O3_PRO",
  OPENAI_O4_MINI = "OPENAI_O4_MINI",
}

/** All values of AgentModel */
export const AGENT_MODEL_VALUES = ['DEFAULT', 'GPT_4_TURBO', 'GPT_4', 'GPT_4_5', 'GPT_4_1', 'GPT_4_1_MINI', 'GPT_4_1_NANO', 'GPT_3_5_TURBO', 'GPT_3_5_TURBO_16K', 'MISTRAL_LARGE', 'OPENAI_O1', 'OPENAI_O1_MINI', 'OPENAI_O3_MINI', 'OPENAI_O3', 'OPENAI_O3_PRO', 'OPENAI_O4_MINI'] as const;

/**
 * Tool publication status in marketplace
 *
 * Values: DRAFT | IN_REVIEW | PUBLISHED_ORG | PUBLISHED | ARCHIVED | DISABLED
 *
 * @generated from schema.prisma:5358
 */
export enum ToolPublicationStatus {
  DRAFT = "DRAFT",
  IN_REVIEW = "IN_REVIEW",
  PUBLISHED_ORG = "PUBLISHED_ORG",
  PUBLISHED = "PUBLISHED",
  ARCHIVED = "ARCHIVED",
  DISABLED = "DISABLED",
}

/** All values of ToolPublicationStatus */
export const TOOL_PUBLICATION_STATUS_VALUES = ['DRAFT', 'IN_REVIEW', 'PUBLISHED_ORG', 'PUBLISHED', 'ARCHIVED', 'DISABLED'] as const;

/**
 * Tool privacy/visibility status
 *
 * Values: PRIVATE | PUBLIC_WITH_CONTRACT | PUBLIC_WITHOUT_CONTRACT | PUBLIC_ORG_WITHOUT_CONTRACT
 *
 * @generated from schema.prisma:5368
 */
export enum ToolPrivacyStatus {
  PRIVATE = "PRIVATE",
  PUBLIC_WITH_CONTRACT = "PUBLIC_WITH_CONTRACT",
  PUBLIC_WITHOUT_CONTRACT = "PUBLIC_WITHOUT_CONTRACT",
  PUBLIC_ORG_WITHOUT_CONTRACT = "PUBLIC_ORG_WITHOUT_CONTRACT",
}

/** All values of ToolPrivacyStatus */
export const TOOL_PRIVACY_STATUS_VALUES = ['PRIVATE', 'PUBLIC_WITH_CONTRACT', 'PUBLIC_WITHOUT_CONTRACT', 'PUBLIC_ORG_WITHOUT_CONTRACT'] as const;

/**
 * Document generation engine type
 *
 * Values: ADOBE | TEMPLATER
 *
 * @generated from schema.prisma:5376
 */
export enum DocumentGenerationType {
  ADOBE = "ADOBE",
  TEMPLATER = "TEMPLATER",
}

/** All values of DocumentGenerationType */
export const DOCUMENT_GENERATION_TYPE_VALUES = ['ADOBE', 'TEMPLATER'] as const;

/**
 * External tool connection type
 *
 * Values: WEBHOOK | API | MANIFEST | CUSTOM_MANIFEST | APIFY | PIPEDREAM | MCP
 *
 * @generated from schema.prisma:5382
 */
export enum AgentExternalToolType {
  WEBHOOK = "WEBHOOK",
  API = "API",
  MANIFEST = "MANIFEST",
  CUSTOM_MANIFEST = "CUSTOM_MANIFEST",
  APIFY = "APIFY",
  PIPEDREAM = "PIPEDREAM",
  MCP = "MCP",
}

/** All values of AgentExternalToolType */
export const AGENT_EXTERNAL_TOOL_TYPE_VALUES = ['WEBHOOK', 'API', 'MANIFEST', 'CUSTOM_MANIFEST', 'APIFY', 'PIPEDREAM', 'MCP'] as const;

/**
 * another one is an additive value.
 *
 * Values: STREAMABLE_HTTP
 *
 * @generated from schema.prisma:5396
 */
export enum McpTransport {
  STREAMABLE_HTTP = "STREAMABLE_HTTP",
}

/** All values of McpTransport */
export const MCP_TRANSPORT_VALUES = ['STREAMABLE_HTTP'] as const;

/**
 * How an MCP server authenticates the backend.
 *
 * Values: NONE | HEADER | OAUTH
 *
 * @generated from schema.prisma:5401
 */
export enum McpAuthMode {
  NONE = "NONE",
  HEADER = "HEADER",
  OAUTH = "OAUTH",
}

/** All values of McpAuthMode */
export const MCP_AUTH_MODE_VALUES = ['NONE', 'HEADER', 'OAUTH'] as const;

/**
 * so the tool list is the only other evidence and it is empty in every case.
 *
 * Values: SUCCEEDED | FAILED | QUEUED
 *
 * @generated from schema.prisma:5421
 */
export enum McpSyncOutcome {
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  QUEUED = "QUEUED",
}

/** All values of McpSyncOutcome */
export const MCP_SYNC_OUTCOME_VALUES = ['SUCCEEDED', 'FAILED', 'QUEUED'] as const;

/**
 * that keeps it consistent with the approval columns is on `McpServerTool`.
 *
 * Values: PENDING_APPROVAL | APPROVED | CHANGED | REMOVED | REJECTED
 *
 * @generated from schema.prisma:5432
 */
export enum McpToolStatus {
  PENDING_APPROVAL = "PENDING_APPROVAL",
  APPROVED = "APPROVED",
  CHANGED = "CHANGED",
  REMOVED = "REMOVED",
  REJECTED = "REJECTED",
}

/** All values of McpToolStatus */
export const MCP_TOOL_STATUS_VALUES = ['PENDING_APPROVAL', 'APPROVED', 'CHANGED', 'REMOVED', 'REJECTED'] as const;

/**
 * Tool type classification
 *
 * Values: TASK | INTERNAL_TOOL | COLLECTION | EXTERNAL_TOOL | FLOW | WORKFLOW | IMAGE_GENERATION | WHATSAPP | PIPEDREAM | PLUGIN | END_CONVERSATION | DOCUMENT_TEMPLATE | MEMORY
 *
 * @generated from schema.prisma:5449
 */
export enum ToolType {
  TASK = "TASK",
  INTERNAL_TOOL = "INTERNAL_TOOL",
  COLLECTION = "COLLECTION",
  EXTERNAL_TOOL = "EXTERNAL_TOOL",
  FLOW = "FLOW",
  WORKFLOW = "WORKFLOW",
  IMAGE_GENERATION = "IMAGE_GENERATION",
  WHATSAPP = "WHATSAPP",
  PIPEDREAM = "PIPEDREAM",
  PLUGIN = "PLUGIN",
  END_CONVERSATION = "END_CONVERSATION",
  DOCUMENT_TEMPLATE = "DOCUMENT_TEMPLATE",
  MEMORY = "MEMORY",
}

/** All values of ToolType */
export const TOOL_TYPE_VALUES = ['TASK', 'INTERNAL_TOOL', 'COLLECTION', 'EXTERNAL_TOOL', 'FLOW', 'WORKFLOW', 'IMAGE_GENERATION', 'WHATSAPP', 'PIPEDREAM', 'PLUGIN', 'END_CONVERSATION', 'DOCUMENT_TEMPLATE', 'MEMORY'] as const;

/**
 * Tool contract status for paid tools
 *
 * Values: TRIAL | ACTIVE | INACTIVE
 *
 * @generated from schema.prisma:5471
 */
export enum ToolContractStatus {
  TRIAL = "TRIAL",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** All values of ToolContractStatus */
export const TOOL_CONTRACT_STATUS_VALUES = ['TRIAL', 'ACTIVE', 'INACTIVE'] as const;

/**
 * Chat conversation status
 *
 * Values: OPEN | RUNNING | ARCHIVED | DELETED
 *
 * @generated from schema.prisma:5478
 */
export enum ChatStatus {
  OPEN = "OPEN",
  RUNNING = "RUNNING",
  ARCHIVED = "ARCHIVED",
  DELETED = "DELETED",
}

/** All values of ChatStatus */
export const CHAT_STATUS_VALUES = ['OPEN', 'RUNNING', 'ARCHIVED', 'DELETED'] as const;

/**
 * Support ticket status for chat
 *
 * Values: SUBMITTED | IN_PROGRESS | WAITING_ON_CUSTOMER | RESOLVED
 *
 * @generated from schema.prisma:5486
 */
export enum ChatTicketStatus {
  SUBMITTED = "SUBMITTED",
  IN_PROGRESS = "IN_PROGRESS",
  WAITING_ON_CUSTOMER = "WAITING_ON_CUSTOMER",
  RESOLVED = "RESOLVED",
}

/** All values of ChatTicketStatus */
export const CHAT_TICKET_STATUS_VALUES = ['SUBMITTED', 'IN_PROGRESS', 'WAITING_ON_CUSTOMER', 'RESOLVED'] as const;

/**
 * Chat response handling mode
 *
 * Values: AUTO | ON_APPROVAL | MANUAL
 *
 * @generated from schema.prisma:5494
 */
export enum ChatResponseHandling {
  AUTO = "AUTO",
  ON_APPROVAL = "ON_APPROVAL",
  MANUAL = "MANUAL",
}

/** All values of ChatResponseHandling */
export const CHAT_RESPONSE_HANDLING_VALUES = ['AUTO', 'ON_APPROVAL', 'MANUAL'] as const;

/**
 * Chat type (playground, API, embed, assistant)
 *
 * Values: MAIN | API | EMBED | ASSISTANT_CREATION
 *
 * @generated from schema.prisma:5501
 */
export enum ChatType {
  MAIN = "MAIN",
  API = "API",
  EMBED = "EMBED",
  ASSISTANT_CREATION = "ASSISTANT_CREATION",
}

/** All values of ChatType */
export const CHAT_TYPE_VALUES = ['MAIN', 'API', 'EMBED', 'ASSISTANT_CREATION'] as const;

/**
 * Chat member role (admin vs member)
 *
 * Values: ADMIN | MEMBER
 *
 * @generated from schema.prisma:5509
 */
export enum ChatMemberRole {
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
}

/** All values of ChatMemberRole */
export const CHAT_MEMBER_ROLE_VALUES = ['ADMIN', 'MEMBER'] as const;

/**
 * Message content type classification
 *
 * Values: SYSTEM | HUMAN | AI | FUNCTION | TOOL
 *
 * @generated from schema.prisma:5515
 */
export enum MessageContentType {
  SYSTEM = "SYSTEM",
  HUMAN = "HUMAN",
  AI = "AI",
  FUNCTION = "FUNCTION",
  TOOL = "TOOL",
}

/** All values of MessageContentType */
export const MESSAGE_CONTENT_TYPE_VALUES = ['SYSTEM', 'HUMAN', 'AI', 'FUNCTION', 'TOOL'] as const;

/**
 * Message processing status
 *
 * Values: PROCESSED | IN_PROGRESS | RUNNING_TOOL | RUNNING_TASK | CANCELLED | WAITING_VALIDATION | INVALIDATED | FAILED
 *
 * @generated from schema.prisma:5524
 */
export enum MessageStatus {
  PROCESSED = "PROCESSED",
  IN_PROGRESS = "IN_PROGRESS",
  RUNNING_TOOL = "RUNNING_TOOL",
  RUNNING_TASK = "RUNNING_TASK",
  CANCELLED = "CANCELLED",
  WAITING_VALIDATION = "WAITING_VALIDATION",
  INVALIDATED = "INVALIDATED",
  FAILED = "FAILED",
}

/** All values of MessageStatus */
export const MESSAGE_STATUS_VALUES = ['PROCESSED', 'IN_PROGRESS', 'RUNNING_TOOL', 'RUNNING_TASK', 'CANCELLED', 'WAITING_VALIDATION', 'INVALIDATED', 'FAILED'] as const;

/**
 * terminal write. SENT / FAILED are terminal.
 *
 * Values: PENDING | SENT | FAILED
 *
 * @generated from schema.prisma:5540
 */
export enum MessageDeliveryStatus {
  PENDING = "PENDING",
  SENT = "SENT",
  FAILED = "FAILED",
}

/** All values of MessageDeliveryStatus */
export const MESSAGE_DELIVERY_STATUS_VALUES = ['PENDING', 'SENT', 'FAILED'] as const;

/**
 * Knowledge source type
 *
 * Values: CHAT | KNOWLEDGE | LIVE
 *
 * @generated from schema.prisma:5547
 */
export enum KnowledgeFrom {
  CHAT = "CHAT",
  KNOWLEDGE = "KNOWLEDGE",
  LIVE = "LIVE",
}

/** All values of KnowledgeFrom */
export const KNOWLEDGE_FROM_VALUES = ['CHAT', 'KNOWLEDGE', 'LIVE'] as const;

/**
 * Knowledge processing and indexing status
 *
 * Values: PROCESSING_VECTORDB | PROCESSING | DONE_VECTORDB | DONE | ERROR_VECTORDB | ERROR | DELETED | INQUEUE | SYNCH
 *
 * @generated from schema.prisma:5554
 */
export enum KnowledgeStatus {
  PROCESSING_VECTORDB = "PROCESSING_VECTORDB",
  PROCESSING = "PROCESSING",
  DONE_VECTORDB = "DONE_VECTORDB",
  DONE = "DONE",
  ERROR_VECTORDB = "ERROR_VECTORDB",
  ERROR = "ERROR",
  DELETED = "DELETED",
  INQUEUE = "INQUEUE",
  SYNCH = "SYNCH",
}

/** All values of KnowledgeStatus */
export const KNOWLEDGE_STATUS_VALUES = ['PROCESSING_VECTORDB', 'PROCESSING', 'DONE_VECTORDB', 'DONE', 'ERROR_VECTORDB', 'ERROR', 'DELETED', 'INQUEUE', 'SYNCH'] as const;

/**
 * figure priced it rather than by anyone choosing, so the row records it.
 *
 * Values: LEAD_ONLY | LEAD_AND_AGENTS
 *
 * @generated from schema.prisma:5571
 */
export enum ChargedPopulation {
  LEAD_ONLY = "LEAD_ONLY",
  LEAD_AND_AGENTS = "LEAD_AND_AGENTS",
}

/** All values of ChargedPopulation */
export const CHARGED_POPULATION_VALUES = ['LEAD_ONLY', 'LEAD_AND_AGENTS'] as const;

/**
 * Values: DEPLOYMENT | PLAYGROUND | WORKFLOW | API | KNOWLEDGE | CUE
 *
 * @generated from schema.prisma:5578
 */
export enum UsageSource {
  DEPLOYMENT = "DEPLOYMENT",
  PLAYGROUND = "PLAYGROUND",
  WORKFLOW = "WORKFLOW",
  API = "API",
  KNOWLEDGE = "KNOWLEDGE",
  CUE = "CUE",
}

/** All values of UsageSource */
export const USAGE_SOURCE_VALUES = ['DEPLOYMENT', 'PLAYGROUND', 'WORKFLOW', 'API', 'KNOWLEDGE', 'CUE'] as const;

/**
 * Granular entity type that originated a token usage record within a request
 *
 * Values: MESSAGE | AGENT | USER | TASK | INTERNAL_TOOL | EXTERNAL_TOOL | ASSISTANT | KNOWLEDGE | TWILIO | CUE
 *
 * @generated from schema.prisma:5588
 */
export enum TokenUsageType {
  MESSAGE = "MESSAGE",
  AGENT = "AGENT",
  USER = "USER",
  TASK = "TASK",
  INTERNAL_TOOL = "INTERNAL_TOOL",
  EXTERNAL_TOOL = "EXTERNAL_TOOL",
  ASSISTANT = "ASSISTANT",
  KNOWLEDGE = "KNOWLEDGE",
  TWILIO = "TWILIO",
  CUE = "CUE",
}

/** All values of TokenUsageType */
export const TOKEN_USAGE_TYPE_VALUES = ['MESSAGE', 'AGENT', 'USER', 'TASK', 'INTERNAL_TOOL', 'EXTERNAL_TOOL', 'ASSISTANT', 'KNOWLEDGE', 'TWILIO', 'CUE'] as const;

/**
 * Token usage key type (custom vs Nexus-provided)
 *
 * Values: CUSTOM | NEXUS
 *
 * @generated from schema.prisma:5602
 */
export enum TokenUsageKeyType {
  CUSTOM = "CUSTOM",
  NEXUS = "NEXUS",
}

/** All values of TokenUsageKeyType */
export const TOKEN_USAGE_KEY_TYPE_VALUES = ['CUSTOM', 'NEXUS'] as const;

/**
 * Tool credential authentication type
 *
 * Values: oauth | user_oauth | service_http | user_http | none | pipedream
 *
 * @generated from schema.prisma:5608
 */
export enum ToolCredentialsType {
  oauth = "oauth",
  user_oauth = "user_oauth",
  service_http = "service_http",
  user_http = "user_http",
  none = "none",
  pipedream = "pipedream",
}

/** All values of ToolCredentialsType */
export const TOOL_CREDENTIALS_TYPE_VALUES = ['oauth', 'user_oauth', 'service_http', 'user_http', 'none', 'pipedream'] as const;

/**
 * OAuth credential status
 *
 * Values: PENDING | ACTIVE | INACTIVE | NEEDS_REAUTH
 *
 * @generated from schema.prisma:5618
 */
export enum OauthCredentialsStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  NEEDS_REAUTH = "NEEDS_REAUTH",
}

/** All values of OauthCredentialsStatus */
export const OAUTH_CREDENTIALS_STATUS_VALUES = ['PENDING', 'ACTIVE', 'INACTIVE', 'NEEDS_REAUTH'] as const;

/**
 * User pricing type (monthly vs one-time)
 *
 * Values: MONTHLY | ONE_TIME
 *
 * @generated from schema.prisma:5629
 */
export enum UserPriceType {
  MONTHLY = "MONTHLY",
  ONE_TIME = "ONE_TIME",
}

/** All values of UserPriceType */
export const USER_PRICE_TYPE_VALUES = ['MONTHLY', 'ONE_TIME'] as const;

/**
 * AI model training status
 *
 * Values: PENDING | TRAINING | DONE | ERROR
 *
 * @generated from schema.prisma:5635
 */
export enum TrainingStatus {
  PENDING = "PENDING",
  TRAINING = "TRAINING",
  DONE = "DONE",
  ERROR = "ERROR",
}

/** All values of TrainingStatus */
export const TRAINING_STATUS_VALUES = ['PENDING', 'TRAINING', 'DONE', 'ERROR'] as const;

/**
 * Deployment channel type (email, chat, messaging, etc.)
 *
 * Values: GMAIL | OUTLOOK | IMAP | SMTP | SLACK | TEAMS | TELEGRAM | FB_MESSENGER | INSTAGRAM | WHATSAPP | TWILIO_SMS | TWILIO_VOICE | GOOGLE_SHEETS | EXCEL_ADDIN | OUTLOOK_ADDIN | POWERPOINT_ADDIN | WORD_ADDIN | AIRTABLE | GOOGLE_MEET | ZOOM | EMBED | API
 *
 * @generated from schema.prisma:5643
 */
export enum DeploymentType {
  GMAIL = "GMAIL",
  OUTLOOK = "OUTLOOK",
  IMAP = "IMAP",
  SMTP = "SMTP",
  SLACK = "SLACK",
  TEAMS = "TEAMS",
  TELEGRAM = "TELEGRAM",
  FB_MESSENGER = "FB_MESSENGER",
  INSTAGRAM = "INSTAGRAM",
  WHATSAPP = "WHATSAPP",
  TWILIO_SMS = "TWILIO_SMS",
  TWILIO_VOICE = "TWILIO_VOICE",
  GOOGLE_SHEETS = "GOOGLE_SHEETS",
  EXCEL_ADDIN = "EXCEL_ADDIN",
  OUTLOOK_ADDIN = "OUTLOOK_ADDIN",
  POWERPOINT_ADDIN = "POWERPOINT_ADDIN",
  WORD_ADDIN = "WORD_ADDIN",
  AIRTABLE = "AIRTABLE",
  GOOGLE_MEET = "GOOGLE_MEET",
  ZOOM = "ZOOM",
  EMBED = "EMBED",
  API = "API",
}

/** All values of DeploymentType */
export const DEPLOYMENT_TYPE_VALUES = ['GMAIL', 'OUTLOOK', 'IMAP', 'SMTP', 'SLACK', 'TEAMS', 'TELEGRAM', 'FB_MESSENGER', 'INSTAGRAM', 'WHATSAPP', 'TWILIO_SMS', 'TWILIO_VOICE', 'GOOGLE_SHEETS', 'EXCEL_ADDIN', 'OUTLOOK_ADDIN', 'POWERPOINT_ADDIN', 'WORD_ADDIN', 'AIRTABLE', 'GOOGLE_MEET', 'ZOOM', 'EMBED', 'API'] as const;

/**
 * Invoice payment status
 *
 * Values: DRAFT | OPEN | PAID | VOID | UNCOLLECTIBLE
 *
 * @generated from schema.prisma:5682
 */
export enum InvoiceStatus {
  DRAFT = "DRAFT",
  OPEN = "OPEN",
  PAID = "PAID",
  VOID = "VOID",
  UNCOLLECTIBLE = "UNCOLLECTIBLE",
}

/** All values of InvoiceStatus */
export const INVOICE_STATUS_VALUES = ['DRAFT', 'OPEN', 'PAID', 'VOID', 'UNCOLLECTIBLE'] as const;

/**
 * Agent task category type
 *
 * Values: GENERATION | CLASSIFICATION | EXTRACTION | TRANSLATION | SUMMARISATION
 *
 * @generated from schema.prisma:5691
 */
export enum AgentTaskCategory {
  GENERATION = "GENERATION",
  CLASSIFICATION = "CLASSIFICATION",
  EXTRACTION = "EXTRACTION",
  TRANSLATION = "TRANSLATION",
  SUMMARISATION = "SUMMARISATION",
}

/** All values of AgentTaskCategory */
export const AGENT_TASK_CATEGORY_VALUES = ['GENERATION', 'CLASSIFICATION', 'EXTRACTION', 'TRANSLATION', 'SUMMARISATION'] as const;

/**
 * Agent tool configuration type
 *
 * Values: WORKFLOW | PLUGIN | TASK | COLLECTION | DOCUMENT_TEMPLATE | MEMORY | MCP
 *
 * @generated from schema.prisma:5700
 */
export enum AgentToolConfigType {
  WORKFLOW = "WORKFLOW",
  PLUGIN = "PLUGIN",
  TASK = "TASK",
  COLLECTION = "COLLECTION",
  DOCUMENT_TEMPLATE = "DOCUMENT_TEMPLATE",
  MEMORY = "MEMORY",
  MCP = "MCP",
}

/** All values of AgentToolConfigType */
export const AGENT_TOOL_CONFIG_TYPE_VALUES = ['WORKFLOW', 'PLUGIN', 'TASK', 'COLLECTION', 'DOCUMENT_TEMPLATE', 'MEMORY', 'MCP'] as const;

/**
 * See @nexus/types SERVICE_TO_PROVIDER for provider derivation
 *
 * Values: GMAIL | GOOGLE_DRIVE | GOOGLE_SHEETS | OUTLOOK | SHAREPOINT | TEAMS_TENANT | NOTION
 *
 * @generated from schema.prisma:5723
 */
export enum OAuthService {
  GMAIL = "GMAIL",
  GOOGLE_DRIVE = "GOOGLE_DRIVE",
  GOOGLE_SHEETS = "GOOGLE_SHEETS",
  OUTLOOK = "OUTLOOK",
  SHAREPOINT = "SHAREPOINT",
  TEAMS_TENANT = "TEAMS_TENANT",
  NOTION = "NOTION",
}

/** All values of OAuthService */
export const O_AUTH_SERVICE_VALUES = ['GMAIL', 'GOOGLE_DRIVE', 'GOOGLE_SHEETS', 'OUTLOOK', 'SHAREPOINT', 'TEAMS_TENANT', 'NOTION'] as const;

/**
 * OAuth connection status
 *
 * Values: CONNECTED | EXPIRING_SOON | NEEDS_REAUTH | DISCONNECTED
 *
 * @generated from schema.prisma:5741
 */
export enum OAuthConnectionStatus {
  CONNECTED = "CONNECTED",
  EXPIRING_SOON = "EXPIRING_SOON",
  NEEDS_REAUTH = "NEEDS_REAUTH",
  DISCONNECTED = "DISCONNECTED",
}

/** All values of OAuthConnectionStatus */
export const O_AUTH_CONNECTION_STATUS_VALUES = ['CONNECTED', 'EXPIRING_SOON', 'NEEDS_REAUTH', 'DISCONNECTED'] as const;

/**
 * server issues no management credential.
 *
 * Values: PRE_REGISTERED | CIMD | DCR
 *
 * @generated from schema.prisma:5757
 */
export enum OAuthClientRegistrationMechanism {
  PRE_REGISTERED = "PRE_REGISTERED",
  CIMD = "CIMD",
  DCR = "DCR",
}

/** All values of OAuthClientRegistrationMechanism */
export const O_AUTH_CLIENT_REGISTRATION_MECHANISM_VALUES = ['PRE_REGISTERED', 'CIMD', 'DCR'] as const;

/**
 * know which of the two it is building.
 *
 * Values: NONE | PRIVATE_KEY_JWT | CLIENT_SECRET_BASIC | CLIENT_SECRET_POST
 *
 * @generated from schema.prisma:5774
 */
export enum OAuthTokenEndpointAuthMethod {
  NONE = "NONE",
  PRIVATE_KEY_JWT = "PRIVATE_KEY_JWT",
  CLIENT_SECRET_BASIC = "CLIENT_SECRET_BASIC",
  CLIENT_SECRET_POST = "CLIENT_SECRET_POST",
}

/** All values of OAuthTokenEndpointAuthMethod */
export const O_AUTH_TOKEN_ENDPOINT_AUTH_METHOD_VALUES = ['NONE', 'PRIVATE_KEY_JWT', 'CLIENT_SECRET_BASIC', 'CLIENT_SECRET_POST'] as const;

/**
 * For services where admin provides static credentials
 *
 * Values: TELEGRAM | TWILIO | SLACK_BOT | SLACK_WORKSPACE | TEAMS_BOT | OFFICE_ADDIN | FB_MESSENGER_PAGE | META_WHATSAPP | META_INSTAGRAM
 *
 * @generated from schema.prisma:5783
 */
export enum ApiKeyService {
  TELEGRAM = "TELEGRAM",
  TWILIO = "TWILIO",
  SLACK_BOT = "SLACK_BOT",
  SLACK_WORKSPACE = "SLACK_WORKSPACE",
  TEAMS_BOT = "TEAMS_BOT",
  OFFICE_ADDIN = "OFFICE_ADDIN",
  FB_MESSENGER_PAGE = "FB_MESSENGER_PAGE",
  META_WHATSAPP = "META_WHATSAPP",
  META_INSTAGRAM = "META_INSTAGRAM",
}

/** All values of ApiKeyService */
export const API_KEY_SERVICE_VALUES = ['TELEGRAM', 'TWILIO', 'SLACK_BOT', 'SLACK_WORKSPACE', 'TEAMS_BOT', 'OFFICE_ADDIN', 'FB_MESSENGER_PAGE', 'META_WHATSAPP', 'META_INSTAGRAM'] as const;

/**
 * Category of vault secrets for organization
 *
 * Values: AI_MODEL | BROWSER_AUTOMATION | OAUTH | WEBHOOK | CUSTOM
 *
 * @generated from schema.prisma:5878
 */
export enum VaultCategory {
  AI_MODEL = "AI_MODEL",
  BROWSER_AUTOMATION = "BROWSER_AUTOMATION",
  OAUTH = "OAUTH",
  WEBHOOK = "WEBHOOK",
  CUSTOM = "CUSTOM",
}

/** All values of VaultCategory */
export const VAULT_CATEGORY_VALUES = ['AI_MODEL', 'BROWSER_AUTOMATION', 'OAUTH', 'WEBHOOK', 'CUSTOM'] as const;

/**
 * Source of vault secret (pool-managed or customer-provided)
 *
 * Values: POOL | BYOK
 *
 * @generated from schema.prisma:5887
 */
export enum VaultSecretSource {
  POOL = "POOL",
  BYOK = "BYOK",
}

/** All values of VaultSecretSource */
export const VAULT_SECRET_SOURCE_VALUES = ['POOL', 'BYOK'] as const;

/**
 * Admin resource type (navigation, block, or action)
 *
 * Values: NAV | BLOCK | ACTION
 *
 * @generated from schema.prisma:5897
 */
export enum NxAdminResourceType {
  NAV = "NAV",
  BLOCK = "BLOCK",
  ACTION = "ACTION",
}

/** All values of NxAdminResourceType */
export const NX_ADMIN_RESOURCE_TYPE_VALUES = ['NAV', 'BLOCK', 'ACTION'] as const;

/**
 * Admin audit log action types (RWX mapping)
 *
 * Values: READ | WRITE | DELETE
 *
 * @generated from schema.prisma:5904
 */
export enum NxAdminAuditAction {
  READ = "READ",
  WRITE = "WRITE",
  DELETE = "DELETE",
}

/** All values of NxAdminAuditAction */
export const NX_ADMIN_AUDIT_ACTION_VALUES = ['READ', 'WRITE', 'DELETE'] as const;

/**
 * Type of metric for appropriate aggregation logic
 *
 * Values: COUNTER | GAUGE | HISTOGRAM
 *
 * @generated from schema.prisma:5944
 */
export enum MetricType {
  COUNTER = "COUNTER",
  GAUGE = "GAUGE",
  HISTOGRAM = "HISTOGRAM",
}

/** All values of MetricType */
export const METRIC_TYPE_VALUES = ['COUNTER', 'GAUGE', 'HISTOGRAM'] as const;

/**
 * Used for distributed locking, execution logging, and type safety
 *
 * Values: EXTERNAL_API_MONITOR | OAUTH_TOKEN_REFRESH | GMAIL_INBOX_WATCH | GMAIL_INBOX_POLL | HEALTH_MONITORING | REDIS_METRICS_COLLECTOR | REDIS_METRICS_COLLECT | METRIC_SNAPSHOT_COLLECT | METRIC_SNAPSHOT_CLEANUP | LLM_TRACING_CLEANUP | HANDSHAKE_CLEANUP | BROWSERBASE_SESSION_CLEANUP_ACTIVE | BROWSERBASE_SESSION_CLEANUP_EXPIRED | BROWSERBASE_MARK_EXPIRED | BROWSERBASE_DELETE_OLD | ECHO_PARTITION_CREATE | ECHO_RECOVERY_MONITOR | ECHO_EXPORTER | ECHO_RETENTION_CLEANUP | ECHO_EXPORT_CLEANUP | DOCUMENTS_SYNC | DOCUMENTS_AUTO_SYNC | DEPLOYMENT_EMAIL_SUBSCRIPTION | EMAIL_SUBSCRIPTION_RENEWAL | BILLING_CHARGES_PROCESS | BILLING_OVERAGES_CHARGE | DASHBOARD_USAGE_ROLLUP | OUTLOOK_INBOX_WATCH | WEEKLY_REPORT | WEEKLY_AGENT_PERFORMANCE_REPORT | WHATSAPP_REDIRECT_TOKEN_CLEANUP | INBOX_INACTIVITY_DETECTOR | VOLUME_SYNC | DAYTONA_TRACING_CLEANUP | PLATFORM_LISTENER_IDLE_SCAN | VIBE_APPROVAL_EXPIRY_SWEEP | VIBE_CONSUMPTION_ROLLUP | VIBE_COST_SAFETY_ROLLBACK_SWEEP | VIBE_BUILD_RUNNER_TICK | VIBE_DEPLOYMENT_RUNNER_TICK | VIBE_BUILD_JOB_TIMEOUT_SWEEP | VIBE_TENANT_CLUSTER_RECONCILE_TICK | VIBE_TENANT_CLUSTER_RECONCILE_STALE_EXECUTION_SWEEP | VIBE_TENANT_CLUSTER_TEARDOWN_TICK | VIBE_CLOUDFLARE_EDGE_SKIP_ENSURE_TICK | VIBE_TENANT_EDGE_TLS_PROBE_TICK | VIBE_APP_BACKUP_FRESHNESS_SWEEP | VIBE_AWS_COST_INGEST_TICK | VIBE_FX_RATE_INGEST_TICK | VIBE_USAGE_ROLLUP_TICK | VIBE_BILLING_CLOSE | VIBE_AUDIT_EXPORT_TICK | VIBE_SCREENSHOT_CAPTURE_TICK | AI_EVALUATION_SPEND_RESET_DAILY | AI_EVALUATION_SPEND_RESET_MONTHLY | CONVERSATION_OUTCOME_CLASSIFY_IDLE | META_INSTAGRAM_TOKEN_REFRESH | VIBE_TENANT_BACKUP_FRESHNESS_SWEEP | VIBE_REGION_QUOTA_HEADROOM_SWEEP | VIBE_TENANT_RESTORE_DRILL_SWEEP | VIBE_OPERATOR_RESTORE_DRILL_POLL | VIBE_GIT_PROJECT_REPOSITORY_SWEEP | VIBE_SERVED_PROBE_TICK | TWILIO_NUMBER_RELEASE_SWEEP | CHECKOUT_GENERATION_SWEEP | BROKER_PARTITION_ENSURE | ROLE_COVERAGE_SNAPSHOT_TICK | TRACKS_INTEGRITY_SWEEP | ROLE_SYSTEM_INTEGRITY_SWEEP | CHAT_RETENTION_SWEEP | VIBE_CUSTOM_DOMAIN_STATUS_SWEEP | VIBE_TENANT_NODE_HEALTH_SWEEP | VIBE_BUILD_SLO_SWEEP | VIBE_FLEET_OBSERVATION_SWEEP | VIBE_EDGE_PROBE_TICK | VIBE_FORCED_CONVERGE_DISPATCH | CLI_AUTH_CLEANUP | SDK_ENVIRONMENT_PURGE
 *
 * @generated from schema.prisma:6035
 */
export enum CronKey {
  EXTERNAL_API_MONITOR = "EXTERNAL_API_MONITOR",
  OAUTH_TOKEN_REFRESH = "OAUTH_TOKEN_REFRESH",
  GMAIL_INBOX_WATCH = "GMAIL_INBOX_WATCH",
  GMAIL_INBOX_POLL = "GMAIL_INBOX_POLL",
  HEALTH_MONITORING = "HEALTH_MONITORING",
  REDIS_METRICS_COLLECTOR = "REDIS_METRICS_COLLECTOR",
  REDIS_METRICS_COLLECT = "REDIS_METRICS_COLLECT",
  METRIC_SNAPSHOT_COLLECT = "METRIC_SNAPSHOT_COLLECT",
  METRIC_SNAPSHOT_CLEANUP = "METRIC_SNAPSHOT_CLEANUP",
  LLM_TRACING_CLEANUP = "LLM_TRACING_CLEANUP",
  HANDSHAKE_CLEANUP = "HANDSHAKE_CLEANUP",
  BROWSERBASE_SESSION_CLEANUP_ACTIVE = "BROWSERBASE_SESSION_CLEANUP_ACTIVE",
  BROWSERBASE_SESSION_CLEANUP_EXPIRED = "BROWSERBASE_SESSION_CLEANUP_EXPIRED",
  BROWSERBASE_MARK_EXPIRED = "BROWSERBASE_MARK_EXPIRED",
  BROWSERBASE_DELETE_OLD = "BROWSERBASE_DELETE_OLD",
  ECHO_PARTITION_CREATE = "ECHO_PARTITION_CREATE",
  ECHO_RECOVERY_MONITOR = "ECHO_RECOVERY_MONITOR",
  ECHO_EXPORTER = "ECHO_EXPORTER",
  ECHO_RETENTION_CLEANUP = "ECHO_RETENTION_CLEANUP",
  ECHO_EXPORT_CLEANUP = "ECHO_EXPORT_CLEANUP",
  DOCUMENTS_SYNC = "DOCUMENTS_SYNC",
  DOCUMENTS_AUTO_SYNC = "DOCUMENTS_AUTO_SYNC",
  DEPLOYMENT_EMAIL_SUBSCRIPTION = "DEPLOYMENT_EMAIL_SUBSCRIPTION",
  EMAIL_SUBSCRIPTION_RENEWAL = "EMAIL_SUBSCRIPTION_RENEWAL",
  BILLING_CHARGES_PROCESS = "BILLING_CHARGES_PROCESS",
  BILLING_OVERAGES_CHARGE = "BILLING_OVERAGES_CHARGE",
  DASHBOARD_USAGE_ROLLUP = "DASHBOARD_USAGE_ROLLUP",
  OUTLOOK_INBOX_WATCH = "OUTLOOK_INBOX_WATCH",
  WEEKLY_REPORT = "WEEKLY_REPORT",
  WEEKLY_AGENT_PERFORMANCE_REPORT = "WEEKLY_AGENT_PERFORMANCE_REPORT",
  WHATSAPP_REDIRECT_TOKEN_CLEANUP = "WHATSAPP_REDIRECT_TOKEN_CLEANUP",
  INBOX_INACTIVITY_DETECTOR = "INBOX_INACTIVITY_DETECTOR",
  VOLUME_SYNC = "VOLUME_SYNC",
  DAYTONA_TRACING_CLEANUP = "DAYTONA_TRACING_CLEANUP",
  PLATFORM_LISTENER_IDLE_SCAN = "PLATFORM_LISTENER_IDLE_SCAN",
  VIBE_APPROVAL_EXPIRY_SWEEP = "VIBE_APPROVAL_EXPIRY_SWEEP",
  VIBE_CONSUMPTION_ROLLUP = "VIBE_CONSUMPTION_ROLLUP",
  VIBE_COST_SAFETY_ROLLBACK_SWEEP = "VIBE_COST_SAFETY_ROLLBACK_SWEEP",
  VIBE_BUILD_RUNNER_TICK = "VIBE_BUILD_RUNNER_TICK",
  VIBE_DEPLOYMENT_RUNNER_TICK = "VIBE_DEPLOYMENT_RUNNER_TICK",
  VIBE_BUILD_JOB_TIMEOUT_SWEEP = "VIBE_BUILD_JOB_TIMEOUT_SWEEP",
  VIBE_TENANT_CLUSTER_RECONCILE_TICK = "VIBE_TENANT_CLUSTER_RECONCILE_TICK",
  VIBE_TENANT_CLUSTER_RECONCILE_STALE_EXECUTION_SWEEP = "VIBE_TENANT_CLUSTER_RECONCILE_STALE_EXECUTION_SWEEP",
  VIBE_TENANT_CLUSTER_TEARDOWN_TICK = "VIBE_TENANT_CLUSTER_TEARDOWN_TICK",
  VIBE_CLOUDFLARE_EDGE_SKIP_ENSURE_TICK = "VIBE_CLOUDFLARE_EDGE_SKIP_ENSURE_TICK",
  VIBE_TENANT_EDGE_TLS_PROBE_TICK = "VIBE_TENANT_EDGE_TLS_PROBE_TICK",
  VIBE_APP_BACKUP_FRESHNESS_SWEEP = "VIBE_APP_BACKUP_FRESHNESS_SWEEP",
  VIBE_AWS_COST_INGEST_TICK = "VIBE_AWS_COST_INGEST_TICK",
  VIBE_FX_RATE_INGEST_TICK = "VIBE_FX_RATE_INGEST_TICK",
  VIBE_USAGE_ROLLUP_TICK = "VIBE_USAGE_ROLLUP_TICK",
  VIBE_BILLING_CLOSE = "VIBE_BILLING_CLOSE",
  VIBE_AUDIT_EXPORT_TICK = "VIBE_AUDIT_EXPORT_TICK",
  VIBE_SCREENSHOT_CAPTURE_TICK = "VIBE_SCREENSHOT_CAPTURE_TICK",
  AI_EVALUATION_SPEND_RESET_DAILY = "AI_EVALUATION_SPEND_RESET_DAILY",
  AI_EVALUATION_SPEND_RESET_MONTHLY = "AI_EVALUATION_SPEND_RESET_MONTHLY",
  CONVERSATION_OUTCOME_CLASSIFY_IDLE = "CONVERSATION_OUTCOME_CLASSIFY_IDLE",
  META_INSTAGRAM_TOKEN_REFRESH = "META_INSTAGRAM_TOKEN_REFRESH",
  VIBE_TENANT_BACKUP_FRESHNESS_SWEEP = "VIBE_TENANT_BACKUP_FRESHNESS_SWEEP",
  VIBE_REGION_QUOTA_HEADROOM_SWEEP = "VIBE_REGION_QUOTA_HEADROOM_SWEEP",
  VIBE_TENANT_RESTORE_DRILL_SWEEP = "VIBE_TENANT_RESTORE_DRILL_SWEEP",
  VIBE_OPERATOR_RESTORE_DRILL_POLL = "VIBE_OPERATOR_RESTORE_DRILL_POLL",
  VIBE_GIT_PROJECT_REPOSITORY_SWEEP = "VIBE_GIT_PROJECT_REPOSITORY_SWEEP",
  VIBE_SERVED_PROBE_TICK = "VIBE_SERVED_PROBE_TICK",
  TWILIO_NUMBER_RELEASE_SWEEP = "TWILIO_NUMBER_RELEASE_SWEEP",
  CHECKOUT_GENERATION_SWEEP = "CHECKOUT_GENERATION_SWEEP",
  BROKER_PARTITION_ENSURE = "BROKER_PARTITION_ENSURE",
  ROLE_COVERAGE_SNAPSHOT_TICK = "ROLE_COVERAGE_SNAPSHOT_TICK",
  TRACKS_INTEGRITY_SWEEP = "TRACKS_INTEGRITY_SWEEP",
  ROLE_SYSTEM_INTEGRITY_SWEEP = "ROLE_SYSTEM_INTEGRITY_SWEEP",
  CHAT_RETENTION_SWEEP = "CHAT_RETENTION_SWEEP",
  VIBE_CUSTOM_DOMAIN_STATUS_SWEEP = "VIBE_CUSTOM_DOMAIN_STATUS_SWEEP",
  VIBE_TENANT_NODE_HEALTH_SWEEP = "VIBE_TENANT_NODE_HEALTH_SWEEP",
  VIBE_BUILD_SLO_SWEEP = "VIBE_BUILD_SLO_SWEEP",
  VIBE_FLEET_OBSERVATION_SWEEP = "VIBE_FLEET_OBSERVATION_SWEEP",
  VIBE_EDGE_PROBE_TICK = "VIBE_EDGE_PROBE_TICK",
  VIBE_FORCED_CONVERGE_DISPATCH = "VIBE_FORCED_CONVERGE_DISPATCH",
  CLI_AUTH_CLEANUP = "CLI_AUTH_CLEANUP",
  SDK_ENVIRONMENT_PURGE = "SDK_ENVIRONMENT_PURGE",
}

/** All values of CronKey */
export const CRON_KEY_VALUES = ['EXTERNAL_API_MONITOR', 'OAUTH_TOKEN_REFRESH', 'GMAIL_INBOX_WATCH', 'GMAIL_INBOX_POLL', 'HEALTH_MONITORING', 'REDIS_METRICS_COLLECTOR', 'REDIS_METRICS_COLLECT', 'METRIC_SNAPSHOT_COLLECT', 'METRIC_SNAPSHOT_CLEANUP', 'LLM_TRACING_CLEANUP', 'HANDSHAKE_CLEANUP', 'BROWSERBASE_SESSION_CLEANUP_ACTIVE', 'BROWSERBASE_SESSION_CLEANUP_EXPIRED', 'BROWSERBASE_MARK_EXPIRED', 'BROWSERBASE_DELETE_OLD', 'ECHO_PARTITION_CREATE', 'ECHO_RECOVERY_MONITOR', 'ECHO_EXPORTER', 'ECHO_RETENTION_CLEANUP', 'ECHO_EXPORT_CLEANUP', 'DOCUMENTS_SYNC', 'DOCUMENTS_AUTO_SYNC', 'DEPLOYMENT_EMAIL_SUBSCRIPTION', 'EMAIL_SUBSCRIPTION_RENEWAL', 'BILLING_CHARGES_PROCESS', 'BILLING_OVERAGES_CHARGE', 'DASHBOARD_USAGE_ROLLUP', 'OUTLOOK_INBOX_WATCH', 'WEEKLY_REPORT', 'WEEKLY_AGENT_PERFORMANCE_REPORT', 'WHATSAPP_REDIRECT_TOKEN_CLEANUP', 'INBOX_INACTIVITY_DETECTOR', 'VOLUME_SYNC', 'DAYTONA_TRACING_CLEANUP', 'PLATFORM_LISTENER_IDLE_SCAN', 'VIBE_APPROVAL_EXPIRY_SWEEP', 'VIBE_CONSUMPTION_ROLLUP', 'VIBE_COST_SAFETY_ROLLBACK_SWEEP', 'VIBE_BUILD_RUNNER_TICK', 'VIBE_DEPLOYMENT_RUNNER_TICK', 'VIBE_BUILD_JOB_TIMEOUT_SWEEP', 'VIBE_TENANT_CLUSTER_RECONCILE_TICK', 'VIBE_TENANT_CLUSTER_RECONCILE_STALE_EXECUTION_SWEEP', 'VIBE_TENANT_CLUSTER_TEARDOWN_TICK', 'VIBE_CLOUDFLARE_EDGE_SKIP_ENSURE_TICK', 'VIBE_TENANT_EDGE_TLS_PROBE_TICK', 'VIBE_APP_BACKUP_FRESHNESS_SWEEP', 'VIBE_AWS_COST_INGEST_TICK', 'VIBE_FX_RATE_INGEST_TICK', 'VIBE_USAGE_ROLLUP_TICK', 'VIBE_BILLING_CLOSE', 'VIBE_AUDIT_EXPORT_TICK', 'VIBE_SCREENSHOT_CAPTURE_TICK', 'AI_EVALUATION_SPEND_RESET_DAILY', 'AI_EVALUATION_SPEND_RESET_MONTHLY', 'CONVERSATION_OUTCOME_CLASSIFY_IDLE', 'META_INSTAGRAM_TOKEN_REFRESH', 'VIBE_TENANT_BACKUP_FRESHNESS_SWEEP', 'VIBE_REGION_QUOTA_HEADROOM_SWEEP', 'VIBE_TENANT_RESTORE_DRILL_SWEEP', 'VIBE_OPERATOR_RESTORE_DRILL_POLL', 'VIBE_GIT_PROJECT_REPOSITORY_SWEEP', 'VIBE_SERVED_PROBE_TICK', 'TWILIO_NUMBER_RELEASE_SWEEP', 'CHECKOUT_GENERATION_SWEEP', 'BROKER_PARTITION_ENSURE', 'ROLE_COVERAGE_SNAPSHOT_TICK', 'TRACKS_INTEGRITY_SWEEP', 'ROLE_SYSTEM_INTEGRITY_SWEEP', 'CHAT_RETENTION_SWEEP', 'VIBE_CUSTOM_DOMAIN_STATUS_SWEEP', 'VIBE_TENANT_NODE_HEALTH_SWEEP', 'VIBE_BUILD_SLO_SWEEP', 'VIBE_FLEET_OBSERVATION_SWEEP', 'VIBE_EDGE_PROBE_TICK', 'VIBE_FORCED_CONVERGE_DISPATCH', 'CLI_AUTH_CLEANUP', 'SDK_ENVIRONMENT_PURGE'] as const;

/**
 * Status of a cron job execution
 *
 * Values: STARTED | SUCCESS | FAILED | SKIPPED | ABANDONED
 *
 * @generated from schema.prisma:6119
 */
export enum CronExecutionStatus {
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
  ABANDONED = "ABANDONED",
}

/** All values of CronExecutionStatus */
export const CRON_EXECUTION_STATUS_VALUES = ['STARTED', 'SUCCESS', 'FAILED', 'SKIPPED', 'ABANDONED'] as const;

/**
 * Type of provider handshake (OAuth vs API key installation)
 *
 * Values: OAUTH_GMAIL | OAUTH_OUTLOOK | OAUTH_GOOGLE_DRIVE | OAUTH_GOOGLE_SHEETS | OAUTH_NOTION | OAUTH_SHAREPOINT | OAUTH_TEAMS_TENANT | OAUTH_EXTERNAL_TOOL | SLACK_APP_INSTALL | TEAMS_BOT_INSTALL | FB_MESSENGER_PAGE_CONNECT | OAUTH_MCP_SERVER
 *
 * @generated from schema.prisma:6137
 */
export enum HandshakeType {
  OAUTH_GMAIL = "OAUTH_GMAIL",
  OAUTH_OUTLOOK = "OAUTH_OUTLOOK",
  OAUTH_GOOGLE_DRIVE = "OAUTH_GOOGLE_DRIVE",
  OAUTH_GOOGLE_SHEETS = "OAUTH_GOOGLE_SHEETS",
  OAUTH_NOTION = "OAUTH_NOTION",
  OAUTH_SHAREPOINT = "OAUTH_SHAREPOINT",
  OAUTH_TEAMS_TENANT = "OAUTH_TEAMS_TENANT",
  OAUTH_EXTERNAL_TOOL = "OAUTH_EXTERNAL_TOOL",
  SLACK_APP_INSTALL = "SLACK_APP_INSTALL",
  TEAMS_BOT_INSTALL = "TEAMS_BOT_INSTALL",
  FB_MESSENGER_PAGE_CONNECT = "FB_MESSENGER_PAGE_CONNECT",
  OAUTH_MCP_SERVER = "OAUTH_MCP_SERVER",
}

/** All values of HandshakeType */
export const HANDSHAKE_TYPE_VALUES = ['OAUTH_GMAIL', 'OAUTH_OUTLOOK', 'OAUTH_GOOGLE_DRIVE', 'OAUTH_GOOGLE_SHEETS', 'OAUTH_NOTION', 'OAUTH_SHAREPOINT', 'OAUTH_TEAMS_TENANT', 'OAUTH_EXTERNAL_TOOL', 'SLACK_APP_INSTALL', 'TEAMS_BOT_INSTALL', 'FB_MESSENGER_PAGE_CONNECT', 'OAUTH_MCP_SERVER'] as const;

/**
 * Status of a provider handshake
 *
 * Values: PENDING | COMPLETED | EXPIRED | FAILED | CANCELLED
 *
 * @generated from schema.prisma:6158
 */
export enum HandshakeStatus {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

/** All values of HandshakeStatus */
export const HANDSHAKE_STATUS_VALUES = ['PENDING', 'COMPLETED', 'EXPIRED', 'FAILED', 'CANCELLED'] as const;

/**
 * Type of connection created by handshake
 *
 * Values: OAUTH | API_KEY | TOOL_CREDENTIALS
 *
 * @generated from schema.prisma:6167
 */
export enum HandshakeConnectionType {
  OAUTH = "OAUTH",
  API_KEY = "API_KEY",
  TOOL_CREDENTIALS = "TOOL_CREDENTIALS",
}

/** All values of HandshakeConnectionType */
export const HANDSHAKE_CONNECTION_TYPE_VALUES = ['OAUTH', 'API_KEY', 'TOOL_CREDENTIALS'] as const;

/**
 * Status for LLM Trace (workflow-level)
 *
 * Values: IN_PROGRESS | COMPLETED | FAILED
 *
 * @generated from schema.prisma:6233
 */
export enum LLMTraceStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of LLMTraceStatus */
export const L_L_M_TRACE_STATUS_VALUES = ['IN_PROGRESS', 'COMPLETED', 'FAILED'] as const;

/**
 * Status for individual LLM Generation
 *
 * Values: PENDING | RUNNING | COMPLETED | FAILED
 *
 * @generated from schema.prisma:6240
 */
export enum LLMGenerationStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of LLMGenerationStatus */
export const L_L_M_GENERATION_STATUS_VALUES = ['PENDING', 'RUNNING', 'COMPLETED', 'FAILED'] as const;

/**
 * Code interpreter session status
 *
 * Values: ACTIVE | EXPIRED
 *
 * @generated from schema.prisma:6248
 */
export enum CodeInterpreterSessionStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

/** All values of CodeInterpreterSessionStatus */
export const CODE_INTERPRETER_SESSION_STATUS_VALUES = ['ACTIVE', 'EXPIRED'] as const;

/**
 * Status of an evaluation session
 *
 * Values: DRAFT | EXECUTING | EXECUTED | JUDGING | COMPLETED | FAILED
 *
 * @generated from schema.prisma:6254
 */
export enum EvaluationSessionStatus {
  DRAFT = "DRAFT",
  EXECUTING = "EXECUTING",
  EXECUTED = "EXECUTED",
  JUDGING = "JUDGING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of EvaluationSessionStatus */
export const EVALUATION_SESSION_STATUS_VALUES = ['DRAFT', 'EXECUTING', 'EXECUTED', 'JUDGING', 'COMPLETED', 'FAILED'] as const;

/**
 * Execution status for individual evaluation results
 *
 * Values: PENDING | RUNNING | COMPLETED | FAILED
 *
 * @generated from schema.prisma:6264
 */
export enum EvaluationExecutionStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of EvaluationExecutionStatus */
export const EVALUATION_EXECUTION_STATUS_VALUES = ['PENDING', 'RUNNING', 'COMPLETED', 'FAILED'] as const;

/**
 * Judge status for individual evaluation results
 *
 * Values: PENDING | RUNNING | COMPLETED | FAILED
 *
 * @generated from schema.prisma:6272
 */
export enum EvaluationJudgeStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** All values of EvaluationJudgeStatus */
export const EVALUATION_JUDGE_STATUS_VALUES = ['PENDING', 'RUNNING', 'COMPLETED', 'FAILED'] as const;

/**
 * Execution status for skill executions (AI tasks, etc.)
 *
 * Values: PENDING | RUNNING | COMPLETED | FAILED | ERROR
 *
 * @generated from schema.prisma:6280
 */
export enum SkillExecutionStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  ERROR = "ERROR",
}

/** All values of SkillExecutionStatus */
export const SKILL_EXECUTION_STATUS_VALUES = ['PENDING', 'RUNNING', 'COMPLETED', 'FAILED', 'ERROR'] as const;

/**
 * Which subsystem owns this Daytona trace.
 *
 * Values: CUE | WORKFLOW_CUSTOM_SCRIPT | AGENT
 *
 * @generated from schema.prisma:6293
 */
export enum DaytonaTraceSource {
  CUE = "CUE",
  WORKFLOW_CUSTOM_SCRIPT = "WORKFLOW_CUSTOM_SCRIPT",
  AGENT = "AGENT",
}

/** All values of DaytonaTraceSource */
export const DAYTONA_TRACE_SOURCE_VALUES = ['CUE', 'WORKFLOW_CUSTOM_SCRIPT', 'AGENT'] as const;

/**
 * Lifecycle status of a Daytona trace.
 *
 * Values: IN_PROGRESS | COMPLETED | FAILED | TIMED_OUT | ABORTED
 *
 * @generated from schema.prisma:6300
 */
export enum DaytonaTraceStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  TIMED_OUT = "TIMED_OUT",
  ABORTED = "ABORTED",
}

/** All values of DaytonaTraceStatus */
export const DAYTONA_TRACE_STATUS_VALUES = ['IN_PROGRESS', 'COMPLETED', 'FAILED', 'TIMED_OUT', 'ABORTED'] as const;

/**
 * Discriminator for individual events within a Daytona trace.
 *
 * Values: CREATE | RESUME | EXEC | UPLOAD_FILE | IPC_EVENT | IPC_RESULT | IPC_TURN_USAGE | DELETE | ERROR | SDK_RAW
 *
 * @generated from schema.prisma:6309
 */
export enum DaytonaEventKind {
  CREATE = "CREATE",
  RESUME = "RESUME",
  EXEC = "EXEC",
  UPLOAD_FILE = "UPLOAD_FILE",
  IPC_EVENT = "IPC_EVENT",
  IPC_RESULT = "IPC_RESULT",
  IPC_TURN_USAGE = "IPC_TURN_USAGE",
  DELETE = "DELETE",
  ERROR = "ERROR",
  SDK_RAW = "SDK_RAW",
}

/** All values of DaytonaEventKind */
export const DAYTONA_EVENT_KIND_VALUES = ['CREATE', 'RESUME', 'EXEC', 'UPLOAD_FILE', 'IPC_EVENT', 'IPC_RESULT', 'IPC_TURN_USAGE', 'DELETE', 'ERROR', 'SDK_RAW'] as const;

/**
 * Outcome of a single Daytona event.
 *
 * Values: OK | ERROR | TIMEOUT
 *
 * @generated from schema.prisma:6323
 */
export enum DaytonaEventOutcome {
  OK = "OK",
  ERROR = "ERROR",
  TIMEOUT = "TIMEOUT",
}

/** All values of DaytonaEventOutcome */
export const DAYTONA_EVENT_OUTCOME_VALUES = ['OK', 'ERROR', 'TIMEOUT'] as const;

/**
 * Category of feature flag for organization
 *
 * Values: FEATURE | EXPERIMENT | OPS | ROLLOUT
 *
 * @generated from schema.prisma:6339
 */
export enum FeatureFlagCategory {
  FEATURE = "FEATURE",
  EXPERIMENT = "EXPERIMENT",
  OPS = "OPS",
  ROLLOUT = "ROLLOUT",
}

/** All values of FeatureFlagCategory */
export const FEATURE_FLAG_CATEGORY_VALUES = ['FEATURE', 'EXPERIMENT', 'OPS', 'ROLLOUT'] as const;

/**
 * data-exchange formats; PDF is a human-readable table snapshot.
 *
 * Values: CSV | JSON | XLSX | PDF
 *
 * @generated from schema.prisma:7174
 */
export enum AnalyticsReportFormat {
  CSV = "CSV",
  JSON = "JSON",
  XLSX = "XLSX",
  PDF = "PDF",
}

/** All values of AnalyticsReportFormat */
export const ANALYTICS_REPORT_FORMAT_VALUES = ['CSV', 'JSON', 'XLSX', 'PDF'] as const;

/**
 * ACTIVE schedules fire on their cron; PAUSED keep their config but never run.
 *
 * Values: ACTIVE | PAUSED
 *
 * @generated from schema.prisma:7182
 */
export enum AnalyticsReportScheduleStatus {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
}

/** All values of AnalyticsReportScheduleStatus */
export const ANALYTICS_REPORT_SCHEDULE_STATUS_VALUES = ['ACTIVE', 'PAUSED'] as const;

/**
 * Outcome of the most recent scheduled-report tick, stamped for observability.
 *
 * Values: SUCCESS | FAILED
 *
 * @generated from schema.prisma:7188
 */
export enum AnalyticsReportRunStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

/** All values of AnalyticsReportRunStatus */
export const ANALYTICS_REPORT_RUN_STATUS_VALUES = ['SUCCESS', 'FAILED'] as const;

/**
 * Resolution status for AI models
 *
 * Values: PENDING | APPROVED | IGNORED
 *
 * @generated from schema.prisma:7275
 */
export enum AiModelResolution {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  IGNORED = "IGNORED",
}

/** All values of AiModelResolution */
export const AI_MODEL_RESOLUTION_VALUES = ['PENDING', 'APPROVED', 'IGNORED'] as const;

/**
 * Nothing is ever deleted by archiving.
 *
 * Values: ACTIVE | ARCHIVED
 *
 * @generated from schema.prisma:7379
 */
export enum PromptVariantStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

/** All values of PromptVariantStatus */
export const PROMPT_VARIANT_STATUS_VALUES = ['ACTIVE', 'ARCHIVED'] as const;

/**
 * ARCHIVED hides it from default lists without deleting anything.
 *
 * Values: DRAFT | READY | ARCHIVED
 *
 * @generated from schema.prisma:7449
 */
export enum GoldenConversationStatus {
  DRAFT = "DRAFT",
  READY = "READY",
  ARCHIVED = "ARCHIVED",
}

/** All values of GoldenConversationStatus */
export const GOLDEN_CONVERSATION_STATUS_VALUES = ['DRAFT', 'READY', 'ARCHIVED'] as const;

/**
 * user; AGENT turns are generated reference replies (possibly hand-edited).
 *
 * Values: USER | AGENT
 *
 * @generated from schema.prisma:7457
 */
export enum TurnRole {
  USER = "USER",
  AGENT = "AGENT",
}

/** All values of TurnRole */
export const TURN_ROLE_VALUES = ['USER', 'AGENT'] as const;

/**
 * ABORTED is the only status that carries an `abortReason`.
 *
 * Values: QUEUED | RUNNING | COMPLETED | FAILED | ABORTED
 *
 * @generated from schema.prisma:7535
 */
export enum PromptEvalRunStatus {
  QUEUED = "QUEUED",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  ABORTED = "ABORTED",
}

/** All values of PromptEvalRunStatus */
export const PROMPT_EVAL_RUN_STATUS_VALUES = ['QUEUED', 'RUNNING', 'COMPLETED', 'FAILED', 'ABORTED'] as const;

/**
 * reaches the cap.
 *
 * Values: USER_REQUESTED | BUDGET_CAP
 *
 * @generated from schema.prisma:7547
 */
export enum PromptEvalAbortReason {
  USER_REQUESTED = "USER_REQUESTED",
  BUDGET_CAP = "BUDGET_CAP",
}

/** All values of PromptEvalAbortReason */
export const PROMPT_EVAL_ABORT_REASON_VALUES = ['USER_REQUESTED', 'BUDGET_CAP'] as const;

/**
 * carries on); SKIPPED when the run stopped before the cell was ever started.
 *
 * Values: PENDING | RUNNING | JUDGED | FAILED | SKIPPED
 *
 * @generated from schema.prisma:7556
 */
export enum PromptEvalCaseStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  JUDGED = "JUDGED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

/** All values of PromptEvalCaseStatus */
export const PROMPT_EVAL_CASE_STATUS_VALUES = ['PENDING', 'RUNNING', 'JUDGED', 'FAILED', 'SKIPPED'] as const;

/**
 * a row is excluded from every mean rather than counted as a zero.
 *
 * Values: PASS | FAIL | INCONCLUSIVE
 *
 * @generated from schema.prisma:7568
 */
export enum PromptEvalVerdict {
  PASS = "PASS",
  FAIL = "FAIL",
  INCONCLUSIVE = "INCONCLUSIVE",
}

/** All values of PromptEvalVerdict */
export const PROMPT_EVAL_VERDICT_VALUES = ['PASS', 'FAIL', 'INCONCLUSIVE'] as const;

/**
 * pause, or an AskUserQuestion answer pause.
 *
 * Values: TOOL_APPROVAL | USER_ANSWER
 *
 * @generated from schema.prisma:7799
 */
export enum RunnerPendingResponseKind {
  TOOL_APPROVAL = "TOOL_APPROVAL",
  USER_ANSWER = "USER_ANSWER",
}

/** All values of RunnerPendingResponseKind */
export const RUNNER_PENDING_RESPONSE_KIND_VALUES = ['TOOL_APPROVAL', 'USER_ANSWER'] as const;

/**
 * reserved for a future writer that intentionally displaces a PENDING row.
 *
 * Values: PENDING | RESOLVED | SUPERSEDED
 *
 * @generated from schema.prisma:7807
 */
export enum RunnerPendingResponseStatus {
  PENDING = "PENDING",
  RESOLVED = "RESOLVED",
  SUPERSEDED = "SUPERSEDED",
}

/** All values of RunnerPendingResponseStatus */
export const RUNNER_PENDING_RESPONSE_STATUS_VALUES = ['PENDING', 'RESOLVED', 'SUPERSEDED'] as const;

/**
 * vocabulary.
 *
 * Values: PENDING | APPROVED | REJECTED
 *
 * @generated from schema.prisma:8195
 */
export enum RoleResourceAccessRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

/** All values of RoleResourceAccessRequestStatus */
export const ROLE_RESOURCE_ACCESS_REQUEST_STATUS_VALUES = ['PENDING', 'APPROVED', 'REJECTED'] as const;

/**
 * as a supported state to every future reader.
 *
 * Values: BUILDING | LIVE | RETIRED
 *
 * @generated from schema.prisma:8445
 */
export enum RoleResourceLifecycle {
  BUILDING = "BUILDING",
  LIVE = "LIVE",
  RETIRED = "RETIRED",
}

/** All values of RoleResourceLifecycle */
export const ROLE_RESOURCE_LIFECYCLE_VALUES = ['BUILDING', 'LIVE', 'RETIRED'] as const;

/**
 * here only once something reads it.
 *
 * Values: CREATE_ROLE | DELETE_ROLE
 *
 * @generated from schema.prisma:8900
 */
export enum RoleManagementAction {
  CREATE_ROLE = "CREATE_ROLE",
  DELETE_ROLE = "DELETE_ROLE",
}

/** All values of RoleManagementAction */
export const ROLE_MANAGEMENT_ACTION_VALUES = ['CREATE_ROLE', 'DELETE_ROLE'] as const;

/**
 * switch then owes a branch.
 *
 * Values: PENDING | APPROVED | REJECTED | SUPERSEDED
 *
 * @generated from schema.prisma:9075
 */
export enum RoleDeletionRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  SUPERSEDED = "SUPERSEDED",
}

/** All values of RoleDeletionRequestStatus */
export const ROLE_DELETION_REQUEST_STATUS_VALUES = ['PENDING', 'APPROVED', 'REJECTED', 'SUPERSEDED'] as const;

/**
 * and is why neither column is required.
 *
 * Values: SALARY | HOURLY | SEAT | DAY | UNIT | FIXED | CREDIT | CUSTOM
 *
 * @generated from schema.prisma:9597
 */
export enum RoleJobTypeBasis {
  SALARY = "SALARY",
  HOURLY = "HOURLY",
  SEAT = "SEAT",
  DAY = "DAY",
  UNIT = "UNIT",
  FIXED = "FIXED",
  CREDIT = "CREDIT",
  CUSTOM = "CUSTOM",
}

/** All values of RoleJobTypeBasis */
export const ROLE_JOB_TYPE_BASIS_VALUES = ['SALARY', 'HOURLY', 'SEAT', 'DAY', 'UNIT', 'FIXED', 'CREDIT', 'CUSTOM'] as const;

/**
 * source model's word instead of being renamed.
 *
 * Values: PEOPLE | PARTNERS | PLATFORM | CREDITS
 *
 * @generated from schema.prisma:9622
 */
export enum RoleJobTypeGroup {
  PEOPLE = "PEOPLE",
  PARTNERS = "PARTNERS",
  PLATFORM = "PLATFORM",
  CREDITS = "CREDITS",
}

/** All values of RoleJobTypeGroup */
export const ROLE_JOB_TYPE_GROUP_VALUES = ['PEOPLE', 'PARTNERS', 'PLATFORM', 'CREDITS'] as const;

/**
 * Target email address for deployment notification emails
 *
 * Values: USER_EMAIL | ORGANIZATION_EMAIL | CUSTOM_EMAIL
 *
 * @generated from schema.prisma:10497
 */
export enum NotificationEmailTarget {
  USER_EMAIL = "USER_EMAIL",
  ORGANIZATION_EMAIL = "ORGANIZATION_EMAIL",
  CUSTOM_EMAIL = "CUSTOM_EMAIL",
}

/** All values of NotificationEmailTarget */
export const NOTIFICATION_EMAIL_TARGET_VALUES = ['USER_EMAIL', 'ORGANIZATION_EMAIL', 'CUSTOM_EMAIL'] as const;

/**
 * Status of an operational issue
 *
 * Values: OPEN | RESOLVED | IGNORED
 *
 * @generated from schema.prisma:10566
 */
export enum IssueStatus {
  OPEN = "OPEN",
  RESOLVED = "RESOLVED",
  IGNORED = "IGNORED",
}

/** All values of IssueStatus */
export const ISSUE_STATUS_VALUES = ['OPEN', 'RESOLVED', 'IGNORED'] as const;

/**
 * and never a row against a stand-in organization.
 *
 * Values: ORGANIZATION | PLATFORM
 *
 * @generated from schema.prisma:10575
 */
export enum IssueScope {
  ORGANIZATION = "ORGANIZATION",
  PLATFORM = "PLATFORM",
}

/** All values of IssueScope */
export const ISSUE_SCOPE_VALUES = ['ORGANIZATION', 'PLATFORM'] as const;

/**
 * `@nexus/types` is derived from this enum, so a severity exists in exactly one place.
 *
 * Values: low | medium | high | critical
 *
 * @generated from schema.prisma:10582
 */
export enum IssueSeverity {
  low = "low",
  medium = "medium",
  high = "high",
  critical = "critical",
}

/** All values of IssueSeverity */
export const ISSUE_SEVERITY_VALUES = ['low', 'medium', 'high', 'critical'] as const;

/**
 * identified by `code`; this is the dimension `code` cannot carry.
 *
 * Values: BACKEND | WORKFLOW
 *
 * @generated from schema.prisma:10591
 */
export enum IssueSource {
  BACKEND = "BACKEND",
  WORKFLOW = "WORKFLOW",
}

/** All values of IssueSource */
export const ISSUE_SOURCE_VALUES = ['BACKEND', 'WORKFLOW'] as const;

/**
 * any inference surface served it.
 *
 * Values: openai | anthropic | google
 *
 * @generated from schema.prisma:10646
 */
export enum CustomModelProtocol {
  openai = "openai",
  anthropic = "anthropic",
  google = "google",
}

/** All values of CustomModelProtocol */
export const CUSTOM_MODEL_PROTOCOL_VALUES = ['openai', 'anthropic', 'google'] as const;

/**
 * Marks a managed (auto-created) public API key with the system that owns it. null source = user-held manual key.
 *
 * Values: CUE | AGENT_FIRST_PARTY_SKILL | VIBE_APP
 *
 * @generated from schema.prisma:10725
 */
export enum ApiKeySource {
  CUE = "CUE",
  AGENT_FIRST_PARTY_SKILL = "AGENT_FIRST_PARTY_SKILL",
  VIBE_APP = "VIBE_APP",
}

/** All values of ApiKeySource */
export const API_KEY_SOURCE_VALUES = ['CUE', 'AGENT_FIRST_PARTY_SKILL', 'VIBE_APP'] as const;

/**
 * Which API surface a PublicApiKey belongs to. See PublicApiKey.kind.
 *
 * Values: NEXUS | SDK
 *
 * @generated from schema.prisma:10750
 */
export enum ApiKeyKind {
  NEXUS = "NEXUS",
  SDK = "SDK",
}

/** All values of ApiKeyKind */
export const API_KEY_KIND_VALUES = ['NEXUS', 'SDK'] as const;

/**
 * the row can never mint another; each move out of a state is one conditional UPDATE.
 *
 * Values: PENDING | APPROVED | DENIED | REDEEMED
 *
 * @generated from schema.prisma:10760
 */
export enum CliLoginStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  REDEEMED = "REDEEMED",
}

/** All values of CliLoginStatus */
export const CLI_LOGIN_STATUS_VALUES = ['PENDING', 'APPROVED', 'DENIED', 'REDEEMED'] as const;

/**
 * SDK per-environment grant level (07 F-PROTO-AUTH-KEYS R3: `none | read | write`).
 *
 * Values: NONE | READ | WRITE
 *
 * @generated from schema.prisma:10768
 */
export enum SdkEnvironmentAccess {
  NONE = "NONE",
  READ = "READ",
  WRITE = "WRITE",
}

/** All values of SdkEnvironmentAccess */
export const SDK_ENVIRONMENT_ACCESS_VALUES = ['NONE', 'READ', 'WRITE'] as const;

/**
 * SDK organization-level grant (07 F-PROTO-AUTH-KEYS R3: `read | write`).
 *
 * Values: READ | WRITE
 *
 * @generated from schema.prisma:10775
 */
export enum SdkOrganizationAccess {
  READ = "READ",
  WRITE = "WRITE",
}

/** All values of SdkOrganizationAccess */
export const SDK_ORGANIZATION_ACCESS_VALUES = ['READ', 'WRITE'] as const;

/**
 * Conversation inbox sort order
 *
 * Values: LAST_ACTIVITY_DESC | LAST_ACTIVITY_ASC | CREATED_DESC | PRIORITY
 *
 * @generated from schema.prisma:10781
 */
export enum ConversationSort {
  LAST_ACTIVITY_DESC = "LAST_ACTIVITY_DESC",
  LAST_ACTIVITY_ASC = "LAST_ACTIVITY_ASC",
  CREATED_DESC = "CREATED_DESC",
  PRIORITY = "PRIORITY",
}

/** All values of ConversationSort */
export const CONVERSATION_SORT_VALUES = ['LAST_ACTIVITY_DESC', 'LAST_ACTIVITY_ASC', 'CREATED_DESC', 'PRIORITY'] as const;

/**
 * Conversation profile visibility scope
 *
 * Values: PRIVATE | ORG
 *
 * @generated from schema.prisma:10789
 */
export enum ConversationProfileVisibility {
  PRIVATE = "PRIVATE",
  ORG = "ORG",
}

/** All values of ConversationProfileVisibility */
export const CONVERSATION_PROFILE_VISIBILITY_VALUES = ['PRIVATE', 'ORG'] as const;

/**
 * Access level a session has on a Workspace's files (read-only vs read-write).
 *
 * Values: READ | READ_WRITE
 *
 * @generated from schema.prisma:10863
 */
export enum WorkspaceMode {
  READ = "READ",
  READ_WRITE = "READ_WRITE",
}

/** All values of WorkspaceMode */
export const WORKSPACE_MODE_VALUES = ['READ', 'READ_WRITE'] as const;

/**
 * (Chapter 26) — the git repo is the source of truth, nothing is copied.
 *
 * Values: DRIVE | CODE
 *
 * @generated from schema.prisma:10871
 */
export enum WorkspaceKind {
  DRIVE = "DRIVE",
  CODE = "CODE",
}

/** All values of WorkspaceKind */
export const WORKSPACE_KIND_VALUES = ['DRIVE', 'CODE'] as const;

/**
 * Workspace. Two members is the whole vocabulary the architecture asked for.
 *
 * Values: ORGANIZATION | GRANTED_ROLES
 *
 * @generated from schema.prisma:10889
 */
export enum ResourceAccessScope {
  ORGANIZATION = "ORGANIZATION",
  GRANTED_ROLES = "GRANTED_ROLES",
}

/** All values of ResourceAccessScope */
export const RESOURCE_ACCESS_SCOPE_VALUES = ['ORGANIZATION', 'GRANTED_ROLES'] as const;

/**
 * Workspace access mode for a cue run, including NONE when no workspace is attached.
 *
 * Values: NONE | READ | READ_WRITE
 *
 * @generated from schema.prisma:10895
 */
export enum CueWorkspaceMode {
  NONE = "NONE",
  READ = "READ",
  READ_WRITE = "READ_WRITE",
}

/** All values of CueWorkspaceMode */
export const CUE_WORKSPACE_MODE_VALUES = ['NONE', 'READ', 'READ_WRITE'] as const;

/**
 * Reachability of a deployed Vibe app over its public URL.
 *
 * Values: PRIVATE | PUBLIC
 *
 * @generated from schema.prisma:11125
 */
export enum VibeAppVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

/** All values of VibeAppVisibility */
export const VIBE_APP_VISIBILITY_VALUES = ['PRIVATE', 'PUBLIC'] as const;

/**
 * orthogonal columns on purpose.
 *
 * Values: ROUTED | UNROUTED | UNAVAILABLE | NO_SUCH_APP | UNKNOWN
 *
 * @generated from schema.prisma:11149
 */
export enum VibeAppEdgeReachability {
  ROUTED = "ROUTED",
  UNROUTED = "UNROUTED",
  UNAVAILABLE = "UNAVAILABLE",
  NO_SUCH_APP = "NO_SUCH_APP",
  UNKNOWN = "UNKNOWN",
}

/** All values of VibeAppEdgeReachability */
export const VIBE_APP_EDGE_REACHABILITY_VALUES = ['ROUTED', 'UNROUTED', 'UNAVAILABLE', 'NO_SUCH_APP', 'UNKNOWN'] as const;

/**
 * second way to say the same thing.
 *
 * Values: UPLOAD | FAVICON
 *
 * @generated from schema.prisma:11178
 */
export enum VibeAppIconSource {
  UPLOAD = "UPLOAD",
  FAVICON = "FAVICON",
}

/** All values of VibeAppIconSource */
export const VIBE_APP_ICON_SOURCE_VALUES = ['UPLOAD', 'FAVICON'] as const;

/**
 * cannot carry a CNAME. It is decided once, when the domain is added.
 *
 * Values: APEX | SUBDOMAIN
 *
 * @generated from schema.prisma:11534
 */
export enum VibeAppDomainKind {
  APEX = "APEX",
  SUBDOMAIN = "SUBDOMAIN",
}

/** All values of VibeAppDomainKind */
export const VIBE_APP_DOMAIN_KIND_VALUES = ['APEX', 'SUBDOMAIN'] as const;

/**
 * authorization decision, not a label.
 *
 * Values: PENDING_DNS | ISSUING_CERT | ACTIVE | FAILED
 *
 * @generated from schema.prisma:11548
 */
export enum VibeAppDomainStatus {
  PENDING_DNS = "PENDING_DNS",
  ISSUING_CERT = "ISSUING_CERT",
  ACTIVE = "ACTIVE",
  FAILED = "FAILED",
}

/** All values of VibeAppDomainStatus */
export const VIBE_APP_DOMAIN_STATUS_VALUES = ['PENDING_DNS', 'ISSUING_CERT', 'ACTIVE', 'FAILED'] as const;

/**
 * Provisioning lifecycle of a Vibe git project (Forgejo repo + push-hook secret).
 *
 * Values: PENDING | READY | FAILED | ARCHIVED
 *
 * @generated from schema.prisma:11640
 */
export enum VibeGitProjectStatus {
  PENDING = "PENDING",
  READY = "READY",
  FAILED = "FAILED",
  ARCHIVED = "ARCHIVED",
}

/** All values of VibeGitProjectStatus */
export const VIBE_GIT_PROJECT_STATUS_VALUES = ['PENDING', 'READY', 'FAILED', 'ARCHIVED'] as const;

/**
 * Blue-green deployment slot a Vibe deployment occupies.
 *
 * Values: BLUE | GREEN
 *
 * @generated from schema.prisma:11845
 */
export enum VibeDeploymentColor {
  BLUE = "BLUE",
  GREEN = "GREEN",
}

/** All values of VibeDeploymentColor */
export const VIBE_DEPLOYMENT_COLOR_VALUES = ['BLUE', 'GREEN'] as const;

/**
 * State machine for a single Vibe deployment attempt (build → approve → deploy → healthy).
 *
 * Values: BUILDING | AWAITING_APPROVAL | DEPLOYING | HEALTHY | FAILED | ROLLED_BACK | SUPERSEDED | DISPLACED | CANCELLED
 *
 * @generated from schema.prisma:11853
 */
export enum VibeDeploymentStatus {
  BUILDING = "BUILDING",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  DEPLOYING = "DEPLOYING",
  HEALTHY = "HEALTHY",
  FAILED = "FAILED",
  ROLLED_BACK = "ROLLED_BACK",
  SUPERSEDED = "SUPERSEDED",
  DISPLACED = "DISPLACED",
  CANCELLED = "CANCELLED",
}

/** All values of VibeDeploymentStatus */
export const VIBE_DEPLOYMENT_STATUS_VALUES = ['BUILDING', 'AWAITING_APPROVAL', 'DEPLOYING', 'HEALTHY', 'FAILED', 'ROLLED_BACK', 'SUPERSEDED', 'DISPLACED', 'CANCELLED'] as const;

/**
 * QUEUED once nothing writes it.
 *
 * Values: PENDING | QUEUED | ADMITTED | STARTING | RUNNING | SUCCEEDED | FAILED | TIMED_OUT | CANCELLED | SUPERSEDED | LOST
 *
 * @generated from schema.prisma:11924
 */
export enum VibeBuildJobStatus {
  PENDING = "PENDING",
  QUEUED = "QUEUED",
  ADMITTED = "ADMITTED",
  STARTING = "STARTING",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  TIMED_OUT = "TIMED_OUT",
  CANCELLED = "CANCELLED",
  SUPERSEDED = "SUPERSEDED",
  LOST = "LOST",
}

/** All values of VibeBuildJobStatus */
export const VIBE_BUILD_JOB_STATUS_VALUES = ['PENDING', 'QUEUED', 'ADMITTED', 'STARTING', 'RUNNING', 'SUCCEEDED', 'FAILED', 'TIMED_OUT', 'CANCELLED', 'SUPERSEDED', 'LOST'] as const;

/**
 * Dockerfile we generate from the detected stack, else Nixpacks.
 *
 * Values: NIXPACKS | DOCKERFILE | GENERATED
 *
 * @generated from schema.prisma:11976
 */
export enum VibeBuilderKind {
  NIXPACKS = "NIXPACKS",
  DOCKERFILE = "DOCKERFILE",
  GENERATED = "GENERATED",
}

/** All values of VibeBuilderKind */
export const VIBE_BUILDER_KIND_VALUES = ['NIXPACKS', 'DOCKERFILE', 'GENERATED'] as const;

/**
 * triggered it.
 *
 * Values: GIT_PUSH | CLI | CONSOLE
 *
 * @generated from schema.prisma:11993
 */
export enum VibeTriggerSource {
  GIT_PUSH = "GIT_PUSH",
  CLI = "CLI",
  CONSOLE = "CONSOLE",
}

/** All values of VibeTriggerSource */
export const VIBE_TRIGGER_SOURCE_VALUES = ['GIT_PUSH', 'CLI', 'CONSOLE'] as const;

/**
 * Which Vibe fleet a given env var is exposed to (all, prod-only, or staging-only).
 *
 * Values: ALL | PROD | STAGING
 *
 * @generated from schema.prisma:12430
 */
export enum VibeEnvVarScope {
  ALL = "ALL",
  PROD = "PROD",
  STAGING = "STAGING",
}

/** All values of VibeEnvVarScope */
export const VIBE_ENV_VAR_SCOPE_VALUES = ['ALL', 'PROD', 'STAGING'] as const;

/**
 * exactly one kind.
 *
 * Values: LITERAL | VAULT_SECRET | CARD
 *
 * @generated from schema.prisma:12467
 */
export enum VibeAppEnvEntryKind {
  LITERAL = "LITERAL",
  VAULT_SECRET = "VAULT_SECRET",
  CARD = "CARD",
}

/** All values of VibeAppEnvEntryKind */
export const VIBE_APP_ENV_ENTRY_KIND_VALUES = ['LITERAL', 'VAULT_SECRET', 'CARD'] as const;

/**
 * the tier, so a new one is wiring rather than a redesign.
 *
 * Values: T1_SHARED | T2_DEDICATED | T3_VOLUME
 *
 * @generated from schema.prisma:12781
 */
export enum VibeDataTier {
  T1_SHARED = "T1_SHARED",
  T2_DEDICATED = "T2_DEDICATED",
  T3_VOLUME = "T3_VOLUME",
}

/** All values of VibeDataTier */
export const VIBE_DATA_TIER_VALUES = ['T1_SHARED', 'T2_DEDICATED', 'T3_VOLUME'] as const;

/**
 * member has to survive an agent restart at any point.
 *
 * Values: PROVISIONING | SYNCING | CUTOVER_PENDING | VERIFYING | DRAINING | FAILED
 *
 * @generated from schema.prisma:12799
 */
export enum VibeDataMigrationState {
  PROVISIONING = "PROVISIONING",
  SYNCING = "SYNCING",
  CUTOVER_PENDING = "CUTOVER_PENDING",
  VERIFYING = "VERIFYING",
  DRAINING = "DRAINING",
  FAILED = "FAILED",
}

/** All values of VibeDataMigrationState */
export const VIBE_DATA_MIGRATION_STATE_VALUES = ['PROVISIONING', 'SYNCING', 'CUTOVER_PENDING', 'VERIFYING', 'DRAINING', 'FAILED'] as const;

/**
 * Exists so a refusal has something to read — see VibeAppSecretRef.managedBy.
 *
 * Values: TENANT | PLATFORM
 *
 * @generated from schema.prisma:12827
 */
export enum VibeResourceOwner {
  TENANT = "TENANT",
  PLATFORM = "PLATFORM",
}

/** All values of VibeResourceOwner */
export const VIBE_RESOURCE_OWNER_VALUES = ['TENANT', 'PLATFORM'] as const;

/**
 * exists to prevent.
 *
 * Values: RUNNING | SUCCEEDED | FAILED | SKIPPED
 *
 * @generated from schema.prisma:13030
 */
export enum VibeAppBackupStatus {
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

/** All values of VibeAppBackupStatus */
export const VIBE_APP_BACKUP_STATUS_VALUES = ['RUNNING', 'SUCCEEDED', 'FAILED', 'SKIPPED'] as const;

/**
 * one) but the reason they carry differs.
 *
 * Values: RUNNING | VERIFIED | FAILED | SKIPPED
 *
 * @generated from schema.prisma:13146
 */
export enum VibeAppRestoreDrillStatus {
  RUNNING = "RUNNING",
  VERIFIED = "VERIFIED",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

/** All values of VibeAppRestoreDrillStatus */
export const VIBE_APP_RESTORE_DRILL_STATUS_VALUES = ['RUNNING', 'VERIFIED', 'FAILED', 'SKIPPED'] as const;

/**
 * git-repo volume.
 *
 * Values: RUNNING | VERIFIED | FAILED | TIMED_OUT | NOTHING_TO_PROVE
 *
 * @generated from schema.prisma:13260
 */
export enum VibeTenantRestoreDrillStatus {
  RUNNING = "RUNNING",
  VERIFIED = "VERIFIED",
  FAILED = "FAILED",
  TIMED_OUT = "TIMED_OUT",
  NOTHING_TO_PROVE = "NOTHING_TO_PROVE",
}

/** All values of VibeTenantRestoreDrillStatus */
export const VIBE_TENANT_RESTORE_DRILL_STATUS_VALUES = ['RUNNING', 'VERIFIED', 'FAILED', 'TIMED_OUT', 'NOTHING_TO_PROVE'] as const;

/**
 * Lifecycle of a prod-deploy approval request gating a Vibe deployment.
 *
 * Values: PENDING | APPROVED | REJECTED | EXPIRED | WITHDRAWN
 *
 * @generated from schema.prisma:13453
 */
export enum VibeApprovalRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
  WITHDRAWN = "WITHDRAWN",
}

/** All values of VibeApprovalRequestStatus */
export const VIBE_APPROVAL_REQUEST_STATUS_VALUES = ['PENDING', 'APPROVED', 'REJECTED', 'EXPIRED', 'WITHDRAWN'] as const;

/**
 * A single reviewer's decision on a Vibe approval request.
 *
 * Values: APPROVE | REJECT
 *
 * @generated from schema.prisma:13480
 */
export enum VibeApprovalDecisionKind {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
}

/** All values of VibeApprovalDecisionKind */
export const VIBE_APPROVAL_DECISION_KIND_VALUES = ['APPROVE', 'REJECT'] as const;

/**
 * git-host instance root (the tightest disk in a tenant). Grown independently.
 *
 * Values: CLIENT_POOL | GIT_HOST
 *
 * @generated from schema.prisma:13579
 */
export enum VibeCapacityApprovalSubject {
  CLIENT_POOL = "CLIENT_POOL",
  GIT_HOST = "GIT_HOST",
}

/** All values of VibeCapacityApprovalSubject */
export const VIBE_CAPACITY_APPROVAL_SUBJECT_VALUES = ['CLIENT_POOL', 'GIT_HOST'] as const;

/**
 * Audit event types recorded across the Vibe deployment, approval, and cost-safety flows.
 *
 * Values: DEPLOYMENT_TRIGGERED | DEPLOYMENT_APPROVED | DEPLOYMENT_REJECTED | APPROVAL_EXPIRED | COST_SAFETY_AUTO_SUSPENDED | COST_SAFETY_SOFT_LIMIT_WARNING | COST_SAFETY_MANUALLY_SUSPENDED | COST_SAFETY_MANUALLY_WARNED | COST_SAFETY_MANUALLY_RESUMED | COST_SAFETY_SOFT_LIMIT_CLEARED | DEPLOYMENT_ROLLED_BACK_COST_SAFETY | BUILD_JOB_SUCCEEDED | DEPLOYMENT_BUILD_SUCCEEDED | BUILD_JOB_FAILED | DEPLOYMENT_FAILED | BUILD_JOB_TIMED_OUT | DEPLOYMENT_HEALTHY | DEPLOYMENT_ROLLED_BACK_HEALTH_CHECK | DEPLOYMENT_SUPERSEDED | DEPLOYMENT_DISPLACED | DEPLOYMENT_ROLLED_BACK_USER | DEPLOYMENT_ROLLED_BACK_CRASH_LOOP | DEPLOYMENT_ROLLED_BACK_FAILED_SMOKE | SECRET_VALUE_STAGED | SECRET_VALUE_WRITTEN | CAPACITY_REQUESTED | CAPACITY_APPROVED | CAPACITY_REJECTED | CAPACITY_EXPIRED | CAPACITY_GROWN | APP_EDGE_UNROUTED | GIT_PUSH_NO_DEPLOY | DEPLOYMENT_SERVED | DEPLOYMENT_VERIFICATION_REFUSED | DEPLOYMENT_VERIFICATION_OVERRIDDEN | DEPLOYMENT_VERIFICATION_WARNED | CARD_GRANT_ISSUED | CARD_GRANT_PAUSED | CARD_GRANT_ACTIVATED | CARD_GRANT_REVOKED | CARD_BINDING_RENAMED | CARD_BINDING_REMOVED | BUILD_JOB_REQUEUED | BUILD_JOB_LOST | DEPLOYMENT_CANCELLED
 *
 * @generated from schema.prisma:13762
 */
export enum VibeAuditEventType {
  DEPLOYMENT_TRIGGERED = "DEPLOYMENT_TRIGGERED",
  DEPLOYMENT_APPROVED = "DEPLOYMENT_APPROVED",
  DEPLOYMENT_REJECTED = "DEPLOYMENT_REJECTED",
  APPROVAL_EXPIRED = "APPROVAL_EXPIRED",
  COST_SAFETY_AUTO_SUSPENDED = "COST_SAFETY_AUTO_SUSPENDED",
  COST_SAFETY_SOFT_LIMIT_WARNING = "COST_SAFETY_SOFT_LIMIT_WARNING",
  COST_SAFETY_MANUALLY_SUSPENDED = "COST_SAFETY_MANUALLY_SUSPENDED",
  COST_SAFETY_MANUALLY_WARNED = "COST_SAFETY_MANUALLY_WARNED",
  COST_SAFETY_MANUALLY_RESUMED = "COST_SAFETY_MANUALLY_RESUMED",
  COST_SAFETY_SOFT_LIMIT_CLEARED = "COST_SAFETY_SOFT_LIMIT_CLEARED",
  DEPLOYMENT_ROLLED_BACK_COST_SAFETY = "DEPLOYMENT_ROLLED_BACK_COST_SAFETY",
  BUILD_JOB_SUCCEEDED = "BUILD_JOB_SUCCEEDED",
  DEPLOYMENT_BUILD_SUCCEEDED = "DEPLOYMENT_BUILD_SUCCEEDED",
  BUILD_JOB_FAILED = "BUILD_JOB_FAILED",
  DEPLOYMENT_FAILED = "DEPLOYMENT_FAILED",
  BUILD_JOB_TIMED_OUT = "BUILD_JOB_TIMED_OUT",
  DEPLOYMENT_HEALTHY = "DEPLOYMENT_HEALTHY",
  DEPLOYMENT_ROLLED_BACK_HEALTH_CHECK = "DEPLOYMENT_ROLLED_BACK_HEALTH_CHECK",
  DEPLOYMENT_SUPERSEDED = "DEPLOYMENT_SUPERSEDED",
  DEPLOYMENT_DISPLACED = "DEPLOYMENT_DISPLACED",
  DEPLOYMENT_ROLLED_BACK_USER = "DEPLOYMENT_ROLLED_BACK_USER",
  DEPLOYMENT_ROLLED_BACK_CRASH_LOOP = "DEPLOYMENT_ROLLED_BACK_CRASH_LOOP",
  DEPLOYMENT_ROLLED_BACK_FAILED_SMOKE = "DEPLOYMENT_ROLLED_BACK_FAILED_SMOKE",
  SECRET_VALUE_STAGED = "SECRET_VALUE_STAGED",
  SECRET_VALUE_WRITTEN = "SECRET_VALUE_WRITTEN",
  CAPACITY_REQUESTED = "CAPACITY_REQUESTED",
  CAPACITY_APPROVED = "CAPACITY_APPROVED",
  CAPACITY_REJECTED = "CAPACITY_REJECTED",
  CAPACITY_EXPIRED = "CAPACITY_EXPIRED",
  CAPACITY_GROWN = "CAPACITY_GROWN",
  APP_EDGE_UNROUTED = "APP_EDGE_UNROUTED",
  GIT_PUSH_NO_DEPLOY = "GIT_PUSH_NO_DEPLOY",
  DEPLOYMENT_SERVED = "DEPLOYMENT_SERVED",
  DEPLOYMENT_VERIFICATION_REFUSED = "DEPLOYMENT_VERIFICATION_REFUSED",
  DEPLOYMENT_VERIFICATION_OVERRIDDEN = "DEPLOYMENT_VERIFICATION_OVERRIDDEN",
  DEPLOYMENT_VERIFICATION_WARNED = "DEPLOYMENT_VERIFICATION_WARNED",
  CARD_GRANT_ISSUED = "CARD_GRANT_ISSUED",
  CARD_GRANT_PAUSED = "CARD_GRANT_PAUSED",
  CARD_GRANT_ACTIVATED = "CARD_GRANT_ACTIVATED",
  CARD_GRANT_REVOKED = "CARD_GRANT_REVOKED",
  CARD_BINDING_RENAMED = "CARD_BINDING_RENAMED",
  CARD_BINDING_REMOVED = "CARD_BINDING_REMOVED",
  BUILD_JOB_REQUEUED = "BUILD_JOB_REQUEUED",
  BUILD_JOB_LOST = "BUILD_JOB_LOST",
  DEPLOYMENT_CANCELLED = "DEPLOYMENT_CANCELLED",
}

/** All values of VibeAuditEventType */
export const VIBE_AUDIT_EVENT_TYPE_VALUES = ['DEPLOYMENT_TRIGGERED', 'DEPLOYMENT_APPROVED', 'DEPLOYMENT_REJECTED', 'APPROVAL_EXPIRED', 'COST_SAFETY_AUTO_SUSPENDED', 'COST_SAFETY_SOFT_LIMIT_WARNING', 'COST_SAFETY_MANUALLY_SUSPENDED', 'COST_SAFETY_MANUALLY_WARNED', 'COST_SAFETY_MANUALLY_RESUMED', 'COST_SAFETY_SOFT_LIMIT_CLEARED', 'DEPLOYMENT_ROLLED_BACK_COST_SAFETY', 'BUILD_JOB_SUCCEEDED', 'DEPLOYMENT_BUILD_SUCCEEDED', 'BUILD_JOB_FAILED', 'DEPLOYMENT_FAILED', 'BUILD_JOB_TIMED_OUT', 'DEPLOYMENT_HEALTHY', 'DEPLOYMENT_ROLLED_BACK_HEALTH_CHECK', 'DEPLOYMENT_SUPERSEDED', 'DEPLOYMENT_DISPLACED', 'DEPLOYMENT_ROLLED_BACK_USER', 'DEPLOYMENT_ROLLED_BACK_CRASH_LOOP', 'DEPLOYMENT_ROLLED_BACK_FAILED_SMOKE', 'SECRET_VALUE_STAGED', 'SECRET_VALUE_WRITTEN', 'CAPACITY_REQUESTED', 'CAPACITY_APPROVED', 'CAPACITY_REJECTED', 'CAPACITY_EXPIRED', 'CAPACITY_GROWN', 'APP_EDGE_UNROUTED', 'GIT_PUSH_NO_DEPLOY', 'DEPLOYMENT_SERVED', 'DEPLOYMENT_VERIFICATION_REFUSED', 'DEPLOYMENT_VERIFICATION_OVERRIDDEN', 'DEPLOYMENT_VERIFICATION_WARNED', 'CARD_GRANT_ISSUED', 'CARD_GRANT_PAUSED', 'CARD_GRANT_ACTIVATED', 'CARD_GRANT_REVOKED', 'CARD_BINDING_RENAMED', 'CARD_BINDING_REMOVED', 'BUILD_JOB_REQUEUED', 'BUILD_JOB_LOST', 'DEPLOYMENT_CANCELLED'] as const;

/**
 * per-organization would leave nothing to prove anything against.
 *
 * Values: OFF | WARN | ENFORCE
 *
 * @generated from schema.prisma:14358
 */
export enum VibeShipGateMode {
  OFF = "OFF",
  WARN = "WARN",
  ENFORCE = "ENFORCE",
}

/** All values of VibeShipGateMode */
export const VIBE_SHIP_GATE_MODE_VALUES = ['OFF', 'WARN', 'ENFORCE'] as const;

/**
 * Org-level cost-safety state gating whether new Vibe deploys are allowed.
 *
 * Values: OK | WARNING | SUSPENDED
 *
 * @generated from schema.prisma:14492
 */
export enum VibeOrgCostSafetyStatus {
  OK = "OK",
  WARNING = "WARNING",
  SUSPENDED = "SUSPENDED",
}

/** All values of VibeOrgCostSafetyStatus */
export const VIBE_ORG_COST_SAFETY_STATUS_VALUES = ['OK', 'WARNING', 'SUSPENDED'] as const;

/**
 * Lifecycle state of an org's dedicated VibeTenantCluster, from initial provisioning through teardown.
 *
 * Values: PROVISIONING | HEALTHY | UPDATING | DEGRADED | DISABLING | DISABLED_RETAINED | DESTROYING | DESTROYED
 *
 * @generated from schema.prisma:14651
 */
export enum VibeTenantClusterStatus {
  PROVISIONING = "PROVISIONING",
  HEALTHY = "HEALTHY",
  UPDATING = "UPDATING",
  DEGRADED = "DEGRADED",
  DISABLING = "DISABLING",
  DISABLED_RETAINED = "DISABLED_RETAINED",
  DESTROYING = "DESTROYING",
  DESTROYED = "DESTROYED",
}

/** All values of VibeTenantClusterStatus */
export const VIBE_TENANT_CLUSTER_STATUS_VALUES = ['PROVISIONING', 'HEALTHY', 'UPDATING', 'DEGRADED', 'DISABLING', 'DISABLED_RETAINED', 'DESTROYING', 'DESTROYED'] as const;

/**
 * the instant of each write. A spec pins this enum to the TypeScript tuple.
 *
 * Values: PROVISIONING | HEALTHY | UPDATING | PENDING_CONFIG_DIFF | DEGRADED | DEGRADED_UNCLASSIFIED | DISABLING | DISABLED_RETAINED | DESTROYING | DESTROYED
 *
 * @generated from schema.prisma:14951
 */
export enum VibeTenantClusterRosterState {
  PROVISIONING = "PROVISIONING",
  HEALTHY = "HEALTHY",
  UPDATING = "UPDATING",
  PENDING_CONFIG_DIFF = "PENDING_CONFIG_DIFF",
  DEGRADED = "DEGRADED",
  DEGRADED_UNCLASSIFIED = "DEGRADED_UNCLASSIFIED",
  DISABLING = "DISABLING",
  DISABLED_RETAINED = "DISABLED_RETAINED",
  DESTROYING = "DESTROYING",
  DESTROYED = "DESTROYED",
}

/** All values of VibeTenantClusterRosterState */
export const VIBE_TENANT_CLUSTER_ROSTER_STATE_VALUES = ['PROVISIONING', 'HEALTHY', 'UPDATING', 'PENDING_CONFIG_DIFF', 'DEGRADED', 'DEGRADED_UNCLASSIFIED', 'DISABLING', 'DISABLED_RETAINED', 'DESTROYING', 'DESTROYED'] as const;

/**
 * carries their identity).
 *
 * Values: RECONCILE_TICK | TEARDOWN_REAPER | OPERATOR_PROVISION | OPERATOR_FORCE_CONVERGE | OPERATOR_DISABLE | OPERATOR_TEARDOWN_COMPLETION | CAPACITY_APPROVAL
 *
 * @generated from schema.prisma:14968
 */
export enum VibeTenantClusterStatusCause {
  RECONCILE_TICK = "RECONCILE_TICK",
  TEARDOWN_REAPER = "TEARDOWN_REAPER",
  OPERATOR_PROVISION = "OPERATOR_PROVISION",
  OPERATOR_FORCE_CONVERGE = "OPERATOR_FORCE_CONVERGE",
  OPERATOR_DISABLE = "OPERATOR_DISABLE",
  OPERATOR_TEARDOWN_COMPLETION = "OPERATOR_TEARDOWN_COMPLETION",
  CAPACITY_APPROVAL = "CAPACITY_APPROVAL",
}

/** All values of VibeTenantClusterStatusCause */
export const VIBE_TENANT_CLUSTER_STATUS_CAUSE_VALUES = ['RECONCILE_TICK', 'TEARDOWN_REAPER', 'OPERATOR_PROVISION', 'OPERATOR_FORCE_CONVERGE', 'OPERATOR_DISABLE', 'OPERATOR_TEARDOWN_COMPLETION', 'CAPACITY_APPROVAL'] as const;

/**
 * surface bootstrap health without ever holding a Vault credential.
 *
 * Values: UNINITIALIZED | BOOTSTRAPPING | READY | ERROR
 *
 * @generated from schema.prisma:15064
 */
export enum VibeAgentVaultState {
  UNINITIALIZED = "UNINITIALIZED",
  BOOTSTRAPPING = "BOOTSTRAPPING",
  READY = "READY",
  ERROR = "ERROR",
}

/** All values of VibeAgentVaultState */
export const VIBE_AGENT_VAULT_STATE_VALUES = ['UNINITIALIZED', 'BOOTSTRAPPING', 'READY', 'ERROR'] as const;

/**
 * second writer racing the pipeline on that column.
 *
 * Values: PENDING | DEPLOYING | HEALTHY | FAILED | ROLLED_BACK
 *
 * @generated from schema.prisma:15077
 */
export enum VibeAgentReportedDeploymentStatus {
  PENDING = "PENDING",
  DEPLOYING = "DEPLOYING",
  HEALTHY = "HEALTHY",
  FAILED = "FAILED",
  ROLLED_BACK = "ROLLED_BACK",
}

/** All values of VibeAgentReportedDeploymentStatus */
export const VIBE_AGENT_REPORTED_DEPLOYMENT_STATUS_VALUES = ['PENDING', 'DEPLOYING', 'HEALTHY', 'FAILED', 'ROLLED_BACK'] as const;

/**
 * git daemon has no blue/green slot to revert to.
 *
 * Values: PENDING | DEPLOYING | HEALTHY | FAILED
 *
 * @generated from schema.prisma:15092
 */
export enum VibeGitHostStatus {
  PENDING = "PENDING",
  DEPLOYING = "DEPLOYING",
  HEALTHY = "HEALTHY",
  FAILED = "FAILED",
}

/** All values of VibeGitHostStatus */
export const VIBE_GIT_HOST_STATUS_VALUES = ['PENDING', 'DEPLOYING', 'HEALTHY', 'FAILED'] as const;

/**
 * telemetry stack has no blue/green slot to revert to.
 *
 * Values: PENDING | DEPLOYING | HEALTHY | FAILED
 *
 * @generated from schema.prisma:15106
 */
export enum VibeTelemetryStatus {
  PENDING = "PENDING",
  DEPLOYING = "DEPLOYING",
  HEALTHY = "HEALTHY",
  FAILED = "FAILED",
}

/** All values of VibeTelemetryStatus */
export const VIBE_TELEMETRY_STATUS_VALUES = ['PENDING', 'DEPLOYING', 'HEALTHY', 'FAILED'] as const;

/**
 * apps/vibe-provisioner/ORIGIN-LOCK-ROLLOUT.md is the runbook.
 *
 * Values: OPEN | SPLIT | LOCKED
 *
 * @generated from schema.prisma:15198
 */
export enum VibeOriginLock {
  OPEN = "OPEN",
  SPLIT = "SPLIT",
  LOCKED = "LOCKED",
}

/** All values of VibeOriginLock */
export const VIBE_ORIGIN_LOCK_VALUES = ['OPEN', 'SPLIT', 'LOCKED'] as const;

/**
 * `VibeTenantCluster.buildExecutor`.
 *
 * Values: NOMAD | CODEBUILD
 *
 * @generated from schema.prisma:15211
 */
export enum VibeBuildExecutor {
  NOMAD = "NOMAD",
  CODEBUILD = "CODEBUILD",
}

/** All values of VibeBuildExecutor */
export const VIBE_BUILD_EXECUTOR_VALUES = ['NOMAD', 'CODEBUILD'] as const;

/**
 * attempt runs on). The agent maps it to the CodeBuild compute type.
 *
 * Values: MEDIUM | LARGE
 *
 * @generated from schema.prisma:15223
 */
export enum VibeBuildComputeSize {
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

/** All values of VibeBuildComputeSize */
export const VIBE_BUILD_COMPUTE_SIZE_VALUES = ['MEDIUM', 'LARGE'] as const;

/**
 * Metered Vibe consumption type (compute minutes, build minutes, or egress MB).
 *
 * Values: VIBE_COMPUTE_MIN | VIBE_BUILD_MIN | VIBE_EGRESS_MB | VIBE_BACKUP_MIN
 *
 * @generated from schema.prisma:15390
 */
export enum VibeUsageType {
  VIBE_COMPUTE_MIN = "VIBE_COMPUTE_MIN",
  VIBE_BUILD_MIN = "VIBE_BUILD_MIN",
  VIBE_EGRESS_MB = "VIBE_EGRESS_MB",
  VIBE_BACKUP_MIN = "VIBE_BACKUP_MIN",
}

/** All values of VibeUsageType */
export const VIBE_USAGE_TYPE_VALUES = ['VIBE_COMPUTE_MIN', 'VIBE_BUILD_MIN', 'VIBE_EGRESS_MB', 'VIBE_BACKUP_MIN'] as const;

/**
 * - COST_PLUS bills `unitCost × (1 + markupPct) × (1 + managementFeePct)`.
 *
 * Values: PRICE_BOOK | COST_PLUS
 *
 * @generated from schema.prisma:15540
 */
export enum VibePricingMode {
  PRICE_BOOK = "PRICE_BOOK",
  COST_PLUS = "COST_PLUS",
}

/** All values of VibePricingMode */
export const VIBE_PRICING_MODE_VALUES = ['PRICE_BOOK', 'COST_PLUS'] as const;

/**
 * Lifecycle of one app's authority over one access card.
 *
 * Values: PENDING_APPROVAL | ACTIVE | PAUSED | REVOKED
 *
 * @generated from schema.prisma:15732
 */
export enum VibeAppCardGrantStatus {
  PENDING_APPROVAL = "PENDING_APPROVAL",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  REVOKED = "REVOKED",
}

/** All values of VibeAppCardGrantStatus */
export const VIBE_APP_CARD_GRANT_STATUS_VALUES = ['PENDING_APPROVAL', 'ACTIVE', 'PAUSED', 'REVOKED'] as const;

/**
 * missing a check the others have.
 *
 * Values: MANUAL_REVOKE | QUOTA_EXHAUSTED | BUDGET_EXHAUSTED | ANOMALY_AUTO_PAUSE | CARD_DELETED | CARD_REVOKED | APP_DELETED | KEY_REVOKED | APPROVAL_GRANTED
 *
 * @generated from schema.prisma:15751
 */
export enum GrantTransitionReason {
  MANUAL_REVOKE = "MANUAL_REVOKE",
  QUOTA_EXHAUSTED = "QUOTA_EXHAUSTED",
  BUDGET_EXHAUSTED = "BUDGET_EXHAUSTED",
  ANOMALY_AUTO_PAUSE = "ANOMALY_AUTO_PAUSE",
  CARD_DELETED = "CARD_DELETED",
  CARD_REVOKED = "CARD_REVOKED",
  APP_DELETED = "APP_DELETED",
  KEY_REVOKED = "KEY_REVOKED",
  APPROVAL_GRANTED = "APPROVAL_GRANTED",
}

/** All values of GrantTransitionReason */
export const GRANT_TRANSITION_REASON_VALUES = ['MANUAL_REVOKE', 'QUOTA_EXHAUSTED', 'BUDGET_EXHAUSTED', 'ANOMALY_AUTO_PAUSE', 'CARD_DELETED', 'CARD_REVOKED', 'APP_DELETED', 'KEY_REVOKED', 'APPROVAL_GRANTED'] as const;

/**
 * How a granted card reaches the app's runtime.
 *
 * Values: HANDLE | SENTINEL | AMBIENT | LEASED_TOKEN
 *
 * @generated from schema.prisma:15891
 */
export enum VibeCardProjection {
  HANDLE = "HANDLE",
  SENTINEL = "SENTINEL",
  AMBIENT = "AMBIENT",
  LEASED_TOKEN = "LEASED_TOKEN",
}

/** All values of VibeCardProjection */
export const VIBE_CARD_PROJECTION_VALUES = ['HANDLE', 'SENTINEL', 'AMBIENT', 'LEASED_TOKEN'] as const;

/**
 * KILLED, not a state.
 *
 * Values: PLANNED | IN_PROGRESS | BLOCKED | IN_REVIEW | DONE
 *
 * @generated from schema.prisma:16384
 */
export enum TrackStatus {
  PLANNED = "PLANNED",
  IN_PROGRESS = "IN_PROGRESS",
  BLOCKED = "BLOCKED",
  IN_REVIEW = "IN_REVIEW",
  DONE = "DONE",
}

/** All values of TrackStatus */
export const TRACK_STATUS_VALUES = ['PLANNED', 'IN_PROGRESS', 'BLOCKED', 'IN_REVIEW', 'DONE'] as const;

/**
 * Values: CUE | USER | EVENT
 *
 * @generated from schema.prisma:16392
 */
export enum TrackNextOwner {
  CUE = "CUE",
  USER = "USER",
  EVENT = "EVENT",
}

/** All values of TrackNextOwner */
export const TRACK_NEXT_OWNER_VALUES = ['CUE', 'USER', 'EVENT'] as const;

/**
 * holds — and counting either inflates the denominator permanently.
 *
 * Values: STEP | DECISION | DEFINITION
 *
 * @generated from schema.prisma:16642
 */
export enum TrackTaskKind {
  STEP = "STEP",
  DECISION = "DECISION",
  DEFINITION = "DEFINITION",
}

/** All values of TrackTaskKind */
export const TRACK_TASK_KIND_VALUES = ['STEP', 'DECISION', 'DEFINITION'] as const;

/**
 * Values: OPEN | CLOSED | DEAD | RETIRED
 *
 * @generated from schema.prisma:16723
 */
export enum TrackAgentState {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  DEAD = "DEAD",
  RETIRED = "RETIRED",
}

/** All values of TrackAgentState */
export const TRACK_AGENT_STATE_VALUES = ['OPEN', 'CLOSED', 'DEAD', 'RETIRED'] as const;

/**
 * Values: PROGRESS | FINDING | DECISION | PROOF | BLOCKER | QUESTION | KILLED | NOTE
 *
 * @generated from schema.prisma:16755
 */
export enum TrackDiaryKind {
  PROGRESS = "PROGRESS",
  FINDING = "FINDING",
  DECISION = "DECISION",
  PROOF = "PROOF",
  BLOCKER = "BLOCKER",
  QUESTION = "QUESTION",
  KILLED = "KILLED",
  NOTE = "NOTE",
}

/** All values of TrackDiaryKind */
export const TRACK_DIARY_KIND_VALUES = ['PROGRESS', 'FINDING', 'DECISION', 'PROOF', 'BLOCKER', 'QUESTION', 'KILLED', 'NOTE'] as const;
